import { Helmet } from 'react-helmet';
import {
    Box,
    Button,
    Card,
    CardHeader,
    CardActions,
    CardContent,
    Chip,
    Container,
    Divider,
    Link,
    Grid,
    Typography,
    Paper,
    TextField,
    Switch,
    FormGroup,
    FormControlLabel,
    MenuItem,
    Select,
    FormHelperText,
    Stepper,
    Step,
    StepLabel,
    Checkbox,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Radio
} from '@mui/material';
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import React, { useEffect } from "react";
import { Link as RouterLink, useNavigate, useParams, useLocation } from "react-router-dom";
import { makeStyles, styled } from "@mui/styles";
import emtyData from "../../../../assets/images/emty-data.png";
import { Formik } from "formik";
import * as Yup from 'yup';
import DialogIcon from "../../../../components/kpi/DialogIcon";
import { useFormik } from 'formik';
import * as yup from 'yup';
import * as Util from "../../../../services/global.service";
import { ReactComponent as DeleteIcon } from "../../../../assets/icons/delete.svg";
import Icon from '@mui/material/Icon';
import SimpleDialog from "../../../../components/SimpleDialog";
import ConfirmDialog from "../../../../components/ConfirmDialog";
import MessageDialog from "../../../../components/inbox/MessageDialog";
import adminService from "../../../../services/admin.service";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers';
import dayjs from 'dayjs'
import { getWorkflow } from "../../../../actions/admin/workflow";
import EvaluationJourney360 from "./EvaluationJourney360";
import { find } from 'lodash';

const styles = {
    path: {
        color: "#68717A",
    },
    icon: {
        color: "#6B6B6B",
        marginBottom: "-3px",
        marginRight: "10px",
    },
    link: {
        color: "#5DA196",
        cursor: "pointer",
    },
    end: {
        color: "#A3A3A3",
    },
    buttonFile: {
        position: "absolute",
        right: "1px",
        top: "1px",
        // bottom: "9px",
        background: "linear-gradient(0deg, #E5E9EC, #E5E9EC), #404349",
        borderLeft: "1px solid #CED4DA",
        "border-radius": "0px 4px 4px 0px",
        width: "100px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    dropdowm: {
        position: "absolute",
        right: "20px",
        top: "40%",
        // bottom: "9px",
        color: "#404349",
        fontSize: "16px",
        // lineHeight: "23.92px",
        fontWeight: "300"
    },
    btnLink: {
        color: "#5DA196",
        cursor: "pointer",
        fontWeight: 500,
        fontSize: '14px',
        fontFamily: 'Kanit',
        lineHeight: '21px',
    },
    disBtnLink: {
        color: "#D8D8D8",
        cursor: "",
        fontWeight: 500,
        fontSize: '14px',
        fontFamily: 'Kanit',
        lineHeight: '21px',
    }
};

const EvaluationJourneyCreate = (props) => {
    const { t, i18n } = useTranslation();
    let { type, serial } = useParams()
    let count = 1;
    const { state } = useLocation();
    const dispatch = useDispatch()
    const useStyles = makeStyles({
        iconContainer: {
            '& svg': {
                width: "45px",
                height: "45px"
            }
        },
        formTextField: {
            '& .MuiTextField-root': { m: 1, width: '25ch' },
        },
        input: {
            '& div > input': {
                height: '8px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },
        inputDate: {
            '& div > input': {
                height: '25px',
                position: "relative"
            },
            '& ::placeholder': {
                fontWeight: '300',
                color: '#AAAAAA',
                fontSize: '16px'
            }
        },

        inputError: {
            '& div > input': {
                color: "#CC6058",
                background: "#CC60581A",
                textAlign: "center",
                height: '6px',
                border: "1px solid #CC6058 !important",
                borderRadius: "4px"
            }
        },

        requiredTitle: {
            color: '#404349',
            fontWeight: '500 !important',
            fontSize: '18px !important'
        },

        textShow: {
            color: '#AAAAAA',
            fontWeight: "500 !important",
            fontSize: '18px !important',
        },

        textShowLittle: {
            color: '#AAAAAA',
            fontWeight: 300,
            fontSize: '16px',
        },

        textShowSmall: {
            color: '#A0A0A0',
            fontWeight: 500,
            fontSize: '14px',
        },

        titleName: {
            color: '#404349',
            fontSize: '24px !important',
            fontWeight: '600 !important'
        },

        textError: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#CC6058',
        },

        root: {
            '& .MuiSvgIcon-root.Mui-active': { color: '#f7b254' },
            "& .MuiStepIcon-root .MuiStepIcon-completed": { color: "#5da196" },
            "& .Mui-disabled .MuiStepIcon-root": { color: "#404349" },
            "& .MuiStepConnector-root span": { border: '0px', borderTop: '1.5px dashed #d7d7d7' },
            "& .MuiStepLabel-label.Mui-completed.MuiStepLabel-alternativeLabel": { color: "#5da196", fontWeight: 400, fontSize: '16px' },
            "& .MuiStepLabel-label.Mui-disabled.MuiStepLabel-alternativeLabel": { color: "#404349", fontWeight: 400, fontSize: '16px' },
            "& .MuiStepLabel-label.Mui-active.MuiStepLabel-alternativeLabel": { color: "#f7b254", fontWeight: 400, fontSize: '16px' },
            '& .Mui-active .MuiStepIcon-text': { display: 'none' },
            '& .Mui-disabled .MuiStepIcon-text': { display: 'none' },
            '& .MuiStepLabel-label.MuiStepLabel-alternativeLabel': { marginTop: '5px' }
        },

        evaluationBox: {
            border: '1px solid #CED4DA',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '23px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        evaluationBoxRequired: {
            border: '1px solid #CC6058',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '23px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        summaryTable: {
            border: '1px solid #CED4DA',
            borderRadius: '5px',
            paddingLeft: '30px !important',
            paddingRight: '30px !important',
            paddingTop: '30px !important',
            marginLeft: '32px !important',
            marginTop: '10px !important',
        },

        checkboxLabel: {
            color: '#404349',
            fontWeight: '400',
            fontSize: '16px'
        },

        checkboxLabelHighlight: {
            color: '#5DA196',
            fontWeight: '600 !important',
            fontSize: '16px'
        },

        table: {
            borderTop: '1px solid #E5E5E5',
            marginTop: '21px',
        },

        tableSummary: {
            marginTop: '0px',
        },

        tableHead: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '30px',
                backgroundColor: '#FAFAFA',
                fontSize: '14px',
                fontWeight: '500',
                color: '#A0A0A0'
            }
        },

        tableHeadBigger: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '50px',
                backgroundColor: '#FAFAFA',
                fontSize: '14px',
                fontWeight: '500',
                color: '#A0A0A0'
            }
        },

        tableBody: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '50px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyWithoutBorder: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                height: '50px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyGoal: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '70px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        tableBodyReview: {
            '& .MuiTableCell-root': {
                padding: '0px',
                paddingLeft: '10px',
                borderBottom: '1px solid #E5E5E5',
                height: '80px',
                fontSize: '16px',
                fontWeight: '400',
                color: '#404349',
                paddingBottom: '4px'
            }
        },

        checkBoxStyle: {
            color: '#CED4DA',
            '&.Mui-checked': {
                color: '#5DA196',
            },
            paddingLeft: '0px',
            '&.Mui-disabled': {
                pointerEvents: 'auto',
                '&:hover': {
                    backgroundColor: 'transparent',
                },
                cursor: 'not-allowed',
                '& .MuiSvgIcon-root': {
                    backgroundColor: '#E4E4E4',
                    borderColor: '#CED4DA'
                },
            },
        },

        checkBoxForShow: {
            color: '#D8D8D8',
            '&.Mui-checked': {
                color: '#D8D8D8',
                fontSize: '20px'
            },
        },

        disabledBox: {
            border: '1px solid #CED4DA',
            backgroundColor: '#E4E4E4',
            borderRadius: 1,
            width: '20px',
            height: '20px',
            margin: '0 auto',
        },

        disabled: {
            background: "#E4E4E4!important",
            color: '#AAAAAA!important',
            "& .MuiInputBase-input": {
                "background-color": "#E4E4E4",
                "-webkit-text-fill-color": "#AAAAAA !important"
            },
            "fieldset": {
                "border-color": "#CED4DA !important"
            },
            '& div > input': {
                height: '8px',
                position: "relative"
            },
        },
        '& Mui-disabled': {
            background: "#E4E4E4!important",
            color: '#AAAAAA!important'
        },
        fillRed: {
            '& > path': {
                fill: "#CC6058"
            },
            '& g > path': {
                fill: "#CC6058"
            },
        },
        selectDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA !important"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            '& div ': {
                padding: "4.05px 14px"
            }
        },
        inputTopicDisabledTextarea: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > textarea': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        },
        inputTopicDisabled: {
            // '& .MuiFormControl-root': {
            background: "#FAFAFA",
            borderRadius: "4px",
            // },
            '& .Mui-disabled': {
                '-webkit-text-fill-color': '#404349 !important',
                borderRadius: "4px",
                backgroundColor: "#FAFAFA"
            },
            '& .MuiOutlinedInput-notchedOutline': {
                border: "none"
            },
            "margin-top": "0px !important",
            "margin-bottom": "0px !important",
            '& div > input': {
                padding: "12.5px 14px",
                "font-size": "16px",
                height: '7px',
                position: "relative"
            }
        }
    })
    const navigate = useNavigate();
    const clickLink = (data) => {
        navigate(data, { replace: false, state: { cycleID: state?.cycleID } });
    }
    const gotoTop = () => {
        const anchor = document.querySelector(
            "#back-to-top-anchor"
        );

        if (anchor) {
            anchor.scrollIntoView({ behavior: "auto", block: "center" });
        }
    }
    const classes = useStyles();

    const [edit, setEdit] = React.useState(true);
    const [save, setSave] = React.useState(false);
    const [cycleList, setCycleList] = React.useState([]);
    const [evaluationType, setEvaluationType] = React.useState([]);
    const [idpTemplate, setIdpTemplate] = React.useState([]);
    const [workflowList, setWorkflowList] = React.useState([]);
    const [options, setOptions] = React.useState([]);
    const [evaluationComponent, setEvaluationComponent] = React.useState([]);
    const [customFormList, setCustomFormList] = React.useState([]);
    const [competencyType, setCompetencyType] = React.useState([]);
    const [probationList, setProbationList] = React.useState([]);
    const [goalWorkflowList, setGoalWorkflowList] = React.useState([]);
    const [goalProgress, setGoalProgress] = React.useState([]);
    const [goalLibrary, setGoalLibrary] = React.useState([]);
    const [ratingScale, setRatingScale] = React.useState([]);
    const [expectRating, setExpectRating] = React.useState([]);
    const [evaExpectRating, setEvaExpectRating] = React.useState([]);
    const [firstEvaTemplate, setFirstEvaTemplate] = React.useState(false);
    const [firstPrTemplate, setFirstPrTemplate] = React.useState(false);
    const [firstGoalTemplate, setFirstGoalTemplate] = React.useState(false);
    const [firstCompetencyTemplate, setFirstCompetencyTemplate] = React.useState(false);
    const [firstProbationGoalTemplate, setFirstProbationGoalTemplate] = React.useState(false);
    const [firstProbationCompetencyTemplate, setFirstProbationCompetencyTemplate] = React.useState(false);
    const [workflowLastday, setWorkflowLastday] = React.useState('');
    const [launchForm, setLaunchForm] = React.useState(false);
    const [cycleType, setCycleType] = React.useState('');
    const [oldData, setOldData] = React.useState({});
    const [show360, setShow360] = React.useState(false);
    const [scoreDecimal, setScoreDecial] = React.useState([
        { serial: '0', code: '0' },
        { serial: '1', code: '1' },
        { serial: '2', code: '2' },
        { serial: '3', code: '3' },
        { serial: '4', code: '4' }
    ]);
    const monthly = ([
        { serial: '1', code: '1' },
        { serial: '2', code: '2' },
        { serial: '3', code: '3' },
        { serial: '4', code: '4' },
        { serial: '5', code: '5' },
        { serial: '6', code: '6' },
        { serial: '7', code: '7' },
        { serial: '8', code: '8' },
        { serial: '9', code: '9' },
        { serial: '10', code: '10' },
        { serial: '11', code: '11' },
        { serial: '12', code: '12' },
    ]);
    const [steps, setSteps] = React.useState([t('admin.inputForm.templateCode'), t('admin.inputForm.evaluationTemplate'), t('admin.inputForm.evaluationSummary')])
    const [activeStep, setActiveStep] = React.useState(0);
    const [calField, setCalField] = React.useState(null);
    const [calTotal, setCalTotal] = React.useState(null);
    const [calType, setCalType] = React.useState(null);
    const [calIdx, setCalIdx] = React.useState(null);
    const [lastState, setLastState] = React.useState(0);
    const [codeExist, setCodeExist] = React.useState(false);
    const [isUsed, setIsUsed] = React.useState(true);
    const [isProbation, setIsProbation] = React.useState(false);

    const validationSchemaStep0 = yup.object({
        code: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
        cycle: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
    });
    const validationSchemaStep1 = yup.object({
        nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
        nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
        evaluationType: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
        scoreDecimal: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
        workflow: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
        total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
        evaluationComponent: yup.array().of(
            yup.object().shape({
                selected: yup.boolean(),
                componentName: yup.string(),
                lists: yup.array().of(
                    yup.object().shape({
                        ratio: yup.string().when("selected", {
                            is: true,
                            then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                        }),
                        custom_form: yup.string().when("selected", {
                            is: true,
                            then: yup.string().when("componentName", {
                                is: "custom",
                                then: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                            })
                        }),
                        allow_evaluate: yup.boolean(),
                        required: yup.object().shape({
                            employee: yup.boolean(),
                            evalutor: yup.boolean()
                        })
                    })
                )
            }),
        )
            .compact((v) => (!v.selected))
            .required(t('admin.inputForm.msgError.pleaseFill')),
        previewWorkflow: yup.array().of(
            yup.object().shape({
                startDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                endDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
            })
        ),
        idpTemplate: yup.string().when("idp", {
            is: true,
            then: yup.string().required(t('admin.inputForm.msgError.pleaseSelect'))
        }),
        prTemplate: yup.string().when("pr", {
            is: true,
            then: yup.string().required(t('admin.inputForm.msgError.pleaseSelect'))
        }),
    });
    const validationSchemaStep1_1 = yup.object({
        probation: yup.object().shape({
            nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            scoreDecimal: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
            workflow: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
            total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
            evaluationComponent: yup.array().of(
                yup.object().shape({
                    selected: yup.boolean(),
                    componentName: yup.string(),
                    lists: yup.array().of(
                        yup.object().shape({
                            ratio: yup.string().when("selected", {
                                is: true,
                                then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                            }),
                            custom_form: yup.string().when("selected", {
                                is: true,
                                then: yup.string().when('componentName', {
                                    is: (componentName) => componentName == 'probation',
                                    then: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                                    otherwise: yup.string().nullable()
                                }),
                                otherwise: yup.string().nullable()
                            }),
                            allow_evaluate: yup.boolean(),
                            requied_custom: yup.boolean(),
                            required: yup.object().shape({
                                employee: yup.boolean(),
                                evalutor: yup.boolean()
                            })
                        })
                    )
                        .compact((v) => (!v.ratio || (v.requied_custom && !v.custom_form)))
                        .required(t('admin.inputForm.msgError.pleaseFill'))
                }),
            )
                .compact((v) => (!v.selected))
                .required(t('admin.inputForm.msgError.pleaseFill')),
        })
    });
    const validationSchemaStep2 = yup.object().shape({
        prTemplateList: yup.array().of(
            yup.object().shape({
                nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                evaluationType: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                scoreDecimal: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                workflow: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                previewWorkflow: yup.array().of(
                    yup.object().shape({
                        startDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                        endDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                    })
                ),
                idpTemplate: yup.string().when("idp", {
                    is: true,
                    then: yup.string().required(t('admin.inputForm.msgError.pleaseSelect'))
                }),
            })
        )
    });
    const validationSchemaStep3 = yup.object().shape({
        goal: yup.object().shape({
            nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            workflow: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
            goalGroup: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
            goalLibrary: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
            total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
            goalCategory: yup.array().of(
                yup.object().shape({
                    selected: yup.boolean(),
                    name: yup.string(),
                    ratio: yup.string().when("selected", {
                        is: true,
                        then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                    })
                })
            )
                .compact((v) => (!v.selected))
                .required(t('admin.inputForm.msgError.pleaseFill')),
            ratingScale: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
            previewWorkflow: yup.array().of(
                yup.object().shape({
                    startDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                    endDate: yup.string().required(t('admin.inputForm.msgError.pleaseFill')),
                })
            ).required(t('admin.inputForm.msgError.pleaseFill')),
        })
    });
    const validationSchemaStep4 = yup.object().shape({
        competency: yup.object().shape({
            nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
            total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
            competencyType: yup.array().of(
                yup.object().shape({
                    selected: yup.boolean(),
                    name: yup.string(),
                    ratio: yup.string().when("selected", {
                        is: true,
                        then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                    })
                })
            )
                .compact((v) => (!v.selected))
                .required(t('admin.inputForm.msgError.pleaseFill'))
        })
    });
    const validationSchemaStep3_1 = yup.object().shape({
        probation: yup.object().shape({
            goal: yup.object().shape({
                nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                workflow: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                goalGroup: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                goalLibrary: yup.string().required(t('admin.inputForm.msgError.pleaseSelect')),
                total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
                goalCategory: yup.array().of(
                    yup.object().shape({
                        selected: yup.boolean(),
                        name: yup.string(),
                        ratio: yup.string().when("selected", {
                            is: true,
                            then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                        })
                    })
                )
                    .compact((v) => (!v.selected))
                    .required(t('admin.inputForm.msgError.pleaseFill')),
                ratingScale: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
            })
        })
    });
    const validationSchemaStep4_1 = yup.object().shape({
        probation: yup.object().shape({
            competency: yup.object().shape({
                nameEn: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                nameTh: yup.string().max(100, " ").required(t('admin.inputForm.msgError.pleaseFill')),
                total: yup.number().required(t('admin.inputForm.msgError.pleaseFill')).min(100).max(100),
                competencyType: yup.array().of(
                    yup.object().shape({
                        selected: yup.boolean(),
                        name: yup.string(),
                        ratio: yup.string().when("selected", {
                            is: true,
                            then: yup.string().required(t('admin.inputForm.msgError.pleaseFill'))
                        })
                    })
                )
                    .compact((v) => (!v.selected))
                    .required(t('admin.inputForm.msgError.pleaseFill'))
            })
        })
    });
    const formik = useFormik({
        initialValues: {
            codeExist: null,
            code: '',
            cycle: '',
            statusActive: true,
            nameEn: '',
            nameTh: '',
            descriptionEn: '',
            descriptionTh: '',
            evaluationType: '',
            scoreDecimal: '',
            workflow: '',
            idp: false,
            idpTemplate: '',
            promotion: false,
            pr: false,
            prTemplate: '',
            prTemplateList: [],
            evaluationComponent: [],
            total: 0,
            previewWorkflow: [],
            is_enforce_start: false,
            allow_evaluator_edit_goal: false,
            probation: {
                statusActive: true,
                nameEn: '',
                nameTh: '',
                descriptionEn: '',
                descriptionTh: '',
                evaluationType: '',
                scoreDecimal: '',
                workflow: '',
                idp: false,
                idpTemplate: '',
                promotion: false,
                pr: false,
                prTemplate: '',
                prTemplateList: [],
                evaluationComponent: [],
                total: 0,
                previewWorkflow: [],
                ratingScale: '',
                expectRating: '',
                is_enforce_start: false,
                allow_evaluator_edit_goal: false,
                goal: {
                    nameEn: '',
                    nameTh: '',
                    descriptionEn: '',
                    descriptionTh: '',
                    workflow: '',
                    total: 0,
                    goalCategory: [],
                    previewWorkflow: [],
                    goalLibrary: '',
                    goalGroup: '',
                    goalProgress: [],
                    scaleMapping: false,
                    ratingScale: '',
                    expectRating: '',
                    ratingScaleList: [],
                    type: [],
                },
                competency: {
                    nameEn: '',
                    nameTh: '',
                    descriptionEn: '',
                    descriptionTh: '',
                    total: 0,
                    competencyType: [],
                },
                summary: []
            },
            goal: {
                nameEn: '',
                nameTh: '',
                descriptionEn: '',
                descriptionTh: '',
                workflow: '',
                total: 0,
                goalCategory: [],
                previewWorkflow: [],
                goalLibrary: '',
                goalGroup: '',
                goalProgress: [],
                scaleMapping: false,
                ratingScale: '',
                expectRating: '',
                ratingScaleList: [],
                type: [],
            },
            competency: {
                nameEn: '',
                nameTh: '',
                descriptionEn: '',
                descriptionTh: '',
                total: 0,
                competencyType: [],
            },
            summary: []
        },
        enableReinitialize: true,
        validationSchema: steps[activeStep] === t('admin.inputForm.templateCode')
            ? validationSchemaStep0
            : steps[activeStep] === t('admin.inputForm.evaluationTemplate')
                ? validationSchemaStep1
                : steps[activeStep] === t('admin.inputForm.probationTemplate')
                    ? validationSchemaStep1_1
                    : steps[activeStep] === t('admin.inputForm.performanceReview')
                        ? validationSchemaStep2
                        : steps[activeStep] === t('admin.inputForm.goalTemplate')
                            ? validationSchemaStep3
                            : steps[activeStep] === t('admin.inputForm.goalProbationTemplate')
                                ? validationSchemaStep3_1
                                : steps[activeStep] === t('admin.inputForm.competencyProbationTemplate')
                                    ? validationSchemaStep4_1
                                    : validationSchemaStep4,
        onSubmit: (values) => {
            if (activeStep !== steps.length - 1) {
                if (activeStep === 0 && activeStep >= lastState) {
                    adminService.getCheckEvaluatiionJourneyCode(formik.values.code).then((resp) => {
                        if (resp.data.success) {
                            if (type !== 'edit') {
                                setCodeExist(resp.data.data.is_exist)
                                setShow360(resp.data.data.is_exist === true ? "" : cycleType === "360")
                            } else {
                                setShow360(cycleType === "360")
                            }
                            if (resp.data.data.is_exist === false || type === 'edit') {
                                adminService.listEvaluationJoruneyTemplate(formik.values.cycle).then((rs) => {
                                    if (rs.success) {
                                        setFirstEvaTemplate(true)
                                        setCompetencyType(rs.data.competency_type)
                                        setCustomFormList(rs.data.custom_form)
                                        setProbationList(rs.data.probation)
                                        setRatingScale(rs.data.rating_scale)
                                        if (isProbation) {
                                            const serialProbation = rs.data?.evaluation_type[0]?.serial
                                            formik.setFieldValue('probation.evaluationType', serialProbation)
                                            if (formik.values.probation.evaluationComponent.length === 0) {
                                                let evaluationComponent = rs.data.evaluation_component.map((item) => {
                                                    return {
                                                        selected: false,
                                                        componentName: item.type,
                                                        lists: [
                                                            {
                                                                ratio: 0,
                                                                allow_evaluate: false,
                                                                custom_form: '',
                                                                requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                required: { employee: false, evaluator: false },
                                                            }
                                                        ],
                                                    }
                                                })
                                                formik.setFieldValue('probation.evaluationComponent', evaluationComponent) //probration
                                            } else {
                                                if (rs.data.evaluation_component.length !== formik.values.probation.evaluationComponent.length) {
                                                    let arrayFilter = [];
                                                    rs.data.evaluation_component.map((item) => {
                                                        let filterData = formik.values.probation.evaluationComponent.filter((data) => data.componentName === item.type);
                                                        if (filterData.length > 0) {
                                                            arrayFilter.push({
                                                                selected: filterData.length > 0,
                                                                componentName: item.type,
                                                                lists: filterData[0]?.lists.map((data) => {
                                                                    return {
                                                                        ratio: data.ratio,
                                                                        custom_form: data.custom_form,
                                                                        requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                        allow_evaluate: data.allow_evaluate ?? false,
                                                                        required: { employee: data.required.employee, evaluator: data.required.evaluator },
                                                                    }
                                                                }),
                                                            })
                                                        } else {
                                                            arrayFilter.push({
                                                                selected: false,
                                                                componentName: item.type,
                                                                lists: [
                                                                    {
                                                                        ratio: 0,
                                                                        custom_form: '',
                                                                        requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                        allow_evaluate: false,
                                                                        required: { employee: false, evaluator: false },
                                                                    }
                                                                ],
                                                            })
                                                        }
                                                    })
                                                    formik.setFieldValue('probation.evaluationComponent', arrayFilter) //probration
                                                }
                                            }
                                            let ratingScaleEvalList = rs.data?.rating_scale?.find((data) => data.serial === formik.values.probation.ratingScale)?.rating_scale.map((item) => {
                                                return {
                                                    scaleLevel: item.level,
                                                    value: item.value,
                                                    descriptionEn: item.description_en,
                                                    descriptionTh: item.description_th,
                                                    serial: item.serial
                                                }
                                            }) ?? []
                                            setEvaExpectRating(ratingScaleEvalList)
                                        } else {
                                            if (formik.values.evaluationComponent.length === 0) {
                                                let evaluationComponent = rs.data.evaluation_component.map((item) => {
                                                    return {
                                                        selected: false,
                                                        componentName: item.type,
                                                        lists: [
                                                            {
                                                                ratio: 0,
                                                                allow_evaluate: false,
                                                                custom_form: '',
                                                                requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                required: { employee: false, evaluator: false },
                                                            }
                                                        ],
                                                    }
                                                })
                                                console.log('evaluationComponent', evaluationComponent)
                                                formik.setFieldValue('evaluationComponent', evaluationComponent)
                                            } else {
                                                if (rs.data.evaluation_component.length !== formik.values.evaluationComponent.length) {
                                                    let arrayFilter = [];
                                                    rs.data.evaluation_component.map((item) => {
                                                        let filterData = formik.values.evaluationComponent.filter((data) => data.componentName === item.type);
                                                        if (filterData.length > 0) {
                                                            arrayFilter.push({
                                                                selected: filterData.length > 0,
                                                                componentName: item.type,
                                                                lists: filterData[0]?.lists.map((data) => {
                                                                    return {
                                                                        ratio: data.ratio,
                                                                        custom_form: data.custom_form,
                                                                        requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                        allow_evaluate: data.allow_evaluate ?? false,
                                                                        required: { employee: data.required.employee, evaluator: data.required.evaluator },
                                                                    }
                                                                }),
                                                            })
                                                        } else {
                                                            arrayFilter.push({
                                                                selected: false,
                                                                componentName: item.type,
                                                                lists: [
                                                                    {
                                                                        ratio: 0,
                                                                        custom_form: '',
                                                                        requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                                                                        allow_evaluate: false,
                                                                        required: { employee: false, evaluator: false },
                                                                    }
                                                                ],
                                                            })
                                                        }
                                                    })
                                                    formik.setFieldValue('evaluationComponent', arrayFilter)
                                                }
                                            }
                                            if (formik.values.previewWorkflow?.length > 0 && cycleType !== "360") {
                                                let workflowSteps = rs.data.workflow.find((item) => item.serial === formik.values.chooseWorkflow.id).workflow_data.steps
                                                let combindSteps = [];
                                                workflowSteps.map((item) => formik.values.previewWorkflow.map((data) => { if (data.serial === item.id) combindSteps.push({ ...data, field: item.fields }) }))
                                                formik.setFieldValue('previewWorkflow', combindSteps)
                                            }
                                        }
                                        setEvaluationComponent(rs.data.evaluation_component)
                                        setWorkflowList(rs.data.workflow)
                                        setOptions(rs.data.options)
                                        setEvaluationType(rs.data.evaluation_type)
                                        setIdpTemplate(rs.data.idp.idp_template)
                                    }
                                })
                                handleNext()
                            }
                        }
                    })
                    let change = false;
                    let step = isProbation ?
                        [t('admin.inputForm.templateCode'), t('admin.inputForm.probationTemplate'), t('admin.inputForm.evaluationSummary')]
                        : [t('admin.inputForm.templateCode'), t('admin.inputForm.evaluationTemplate'), t('admin.inputForm.evaluationSummary')]
                    if (JSON.stringify(step) !== JSON.stringify(steps)) {
                        setSteps(step)
                        change = true;
                    }
                }
                if (activeStep === 1) {
                    let change = false;
                    if (isProbation) { //probation
                        let step = [t('admin.inputForm.templateCode'), t('admin.inputForm.probationTemplate')]
                        if (formik.values.probation.evaluationComponent.length > 0) {
                            formik.values.probation.evaluationComponent.map((item, idx) => {
                                if (idx === 0 && item.selected === true) {
                                    step.push(t('admin.inputForm.goalProbationTemplate'))
                                } else if (idx === 1 && item.selected === true) {
                                    step.push(t('admin.inputForm.competencyProbationTemplate'))
                                }
                            })
                        }
                        step.push(t('admin.inputForm.evaluationSummary'))
                        if (JSON.stringify(step) !== JSON.stringify(steps)) {
                            setSteps(step)
                            change = true;
                        }

                        if (formik.values.probation.evaluationComponent[0].selected && (activeStep >= lastState || change)) {
                            adminService.listEvaluationJoruneyGoalTemplate(formik.values.cycle).then((rs) => {
                                setFirstGoalTemplate(true)
                                setFirstProbationGoalTemplate(true)
                                setGoalWorkflowList(rs.data.workflow)
                                setGoalProgress(rs.data.goal_progress_group)
                                setGoalLibrary(rs.data.goal_library)
                                setRatingScale(rs.data.rating_scale)

                                const goalGroupData = rs.data?.goal_progress_group?.filter((item) => item)[0];

                                formik.setFieldValue('probation.goal.goalGroup', goalGroupData.serial)

                                const goalGroupProgress = goalGroupData.goal_progress_data.map((item) => {
                                    return {
                                        seq: item.seq,
                                        name: item.name,
                                        nameTh: item.name_th,
                                        nameEn: item.name_en,
                                        color: JSON.parse(item.color),
                                        serial: item.serial,
                                        selected: item.is_default
                                    }
                                })
                                formik.setFieldValue('probation.goal.goalProgress', goalGroupProgress)

                                let defaultLibrary = rs.data.goal_library.filter((item) => item.is_default)[0].serial;
                                if (formik.values?.probation?.goal?.goalLibrary && find(rs.data.goal_library, { serial: formik.values.probation.goal.goalLibrary })) defaultLibrary = formik.values.probation.goal.goalLibrary.goalLibrary

                                formik.setFieldValue('probation.goal.goalLibrary', defaultLibrary)

                                if (formik.values.goal.goalCategory.length === 0) {
                                    let goalCategoryList = rs.data.goal_category.map((item) => {
                                        return {
                                            selected: false,
                                            name: item.name,
                                            serial: item.serial,
                                            ratio: '',
                                        }
                                    })
                                    formik.setFieldValue('probation.goal.goalCategory', goalCategoryList)
                                } else {
                                    if (rs.data.goal_category.length !== formik.values.probation.goal.goalCategory.length) {
                                        let arrayFilter = [];
                                        rs.data.goal_category.map((item) => {
                                            let filterData = formik.values.probation.goal.goalCategory.filter((item2) => item2.serial === item.serial);
                                            if (filterData.length > 0) {
                                                arrayFilter.push({
                                                    selected: filterData.length > 0,
                                                    serial: item.serial,
                                                    name: item.name,
                                                    ratio: filterData[0].ratio,
                                                })
                                            } else {
                                                arrayFilter.push({
                                                    selected: false,
                                                    serial: item.serial,
                                                    name: item.name,
                                                    ratio: 0,
                                                })
                                            }

                                        })
                                        formik.setFieldValue('probation.goal.goalCategory', arrayFilter)
                                    }
                                }

                                let filterSelect = rs.data.goal_type.filter((data) => data.name === 'Personal Goal').map((item) => {
                                    return {
                                        is_default: true,
                                        description: item.description,
                                        seq: item.seq,
                                        serial: item.serial,
                                        name: item.name,
                                    }
                                })
                                formik.setFieldValue('probation.goal.type', filterSelect)
                            })
                        }
                        if (formik.values.probation.evaluationComponent[1].selected && (activeStep >= lastState || change)) {
                            adminService.listEvaluationJoruneyCompetencyTemplate(formik.values.cycle).then((rs) => {
                                if (rs.success) {
                                    setFirstCompetencyTemplate(true)
                                    setFirstProbationCompetencyTemplate(true)
                                    if (formik.values.probation.competency.competencyType.length === 0) {
                                        let competencyList = rs.data.competency_type.map((item) => {
                                            return {
                                                selected: false,
                                                name: item.name,
                                                serial: item.serial,
                                                ratio: '',
                                            }
                                        })
                                        formik.setFieldValue('probation.competency.competencyType', competencyList);
                                    } else {
                                        if (rs.data.competency_type.length !== formik.values.probation.competency.competencyType.length) {
                                            let arrayFilter = [];
                                            rs.data.competency_type.map((item) => {
                                                let filterData = formik.values.probation.competency.competencyType.filter((data) => data.serial === item.serial);
                                                if (filterData.length > 0) {
                                                    arrayFilter.push({
                                                        selected: filterData.length > 0,
                                                        name: item.name,
                                                        ratio: filterData[0].ratio,
                                                        serial: item.serial,
                                                        ...item
                                                    })
                                                } else {
                                                    arrayFilter.push({
                                                        selected: false,
                                                        name: item.name,
                                                        serial: item.serial,
                                                        ratio: '',
                                                    })
                                                }
                                            })
                                            formik.setFieldValue('probation.competency.competencyType', arrayFilter)
                                        }
                                    }
                                }
                            })
                        }
                    } else {
                        let step = [t('admin.inputForm.templateCode'), t('admin.inputForm.evaluationTemplate')]
                        if (formik.values.pr) {
                            step.push(t('admin.inputForm.performanceReview'))
                        }
                        if (formik.values.evaluationComponent.length > 0) {
                            formik.values.evaluationComponent.map((item, idx) => {
                                if (idx === 0 && item.selected === true) {
                                    step.push(t('admin.inputForm.goalTemplate'))
                                } else if (idx === 1 && item.selected === true) {
                                    step.push(t('admin.inputForm.competencyTemplate'))
                                }
                            })
                        }
                        step.push(t('admin.inputForm.evaluationSummary'))
                        if (JSON.stringify(step) !== JSON.stringify(steps)) {
                            setSteps(step)
                            change = true;
                        }

                        if (formik.values.evaluationComponent[0].selected && (activeStep >= lastState || change)) {
                            adminService.listEvaluationJoruneyGoalTemplate(formik.values.cycle).then((rs) => {
                                setFirstGoalTemplate(true)
                                setFirstProbationGoalTemplate(true)
                                setGoalWorkflowList(rs.data.workflow)
                                setGoalProgress(rs.data.goal_progress_group)
                                setGoalLibrary(rs.data.goal_library)
                                setRatingScale(rs.data.rating_scale)

                                const goalGroupData = rs.data?.goal_progress_group?.filter((item) => item)[0];

                                formik.setFieldValue('goal.goalGroup', goalGroupData.serial)

                                const goalGroupProgress = goalGroupData.goal_progress_data.map((item) => {
                                    return {
                                        seq: item.seq,
                                        name: item.name,
                                        nameTh: item.name_th,
                                        nameEn: item.name_en,
                                        color: JSON.parse(item.color),
                                        serial: item.serial,
                                        selected: item.is_default
                                    }
                                })
                                formik.setFieldValue('goal.goalProgress', goalGroupProgress)

                                let defaultLibrary = rs.data.goal_library.filter((item) => item.is_default)[0].serial;
                                if (formik.values?.goal?.goalLibrary && find(rs.data.goal_library, { serial: formik.values.goal.goalLibrary })) defaultLibrary = formik.values.goal.goalLibrary


                                if (formik.values.goal.goalCategory.length === 0) {
                                    let goalCategoryList = rs.data.goal_category.map((item) => {
                                        return {
                                            selected: false,
                                            name: item.name,
                                            serial: item.serial,
                                            ratio: '',
                                        }
                                    })
                                    formik.setFieldValue('goal.goalCategory', goalCategoryList)
                                } else {
                                    if (rs.data.goal_category.length !== formik.values.goal.goalCategory.length) {
                                        let arrayFilter = [];
                                        rs.data.goal_category.map((item) => {
                                            let filterData = formik.values.goal.goalCategory.filter((item2) => item2.serial === item.serial);
                                            if (filterData.length > 0) {
                                                arrayFilter.push({
                                                    selected: filterData.length > 0,
                                                    serial: item.serial,
                                                    name: item.name,
                                                    ratio: filterData[0].ratio,
                                                })
                                            } else {
                                                arrayFilter.push({
                                                    selected: false,
                                                    serial: item.serial,
                                                    name: item.name,
                                                    ratio: 0,
                                                })
                                            }

                                        })
                                        formik.setFieldValue('goal.goalCategory', arrayFilter)
                                    }
                                }


                                if (formik.values.goal.type.length === 0) {
                                    let filterSelect = rs.data.goal_type.map((item) => {
                                        return {
                                            is_default: false,
                                            description: item.description,
                                            seq: item.seq,
                                            serial: item.serial,
                                            name: item.name,
                                        }
                                    })
                                    formik.setFieldValue('goal.type', filterSelect)
                                } else {
                                    if (rs.data.goal_type.length !== formik.values.goal.type.length) {
                                        let arrayFilter = [];
                                        rs.data.goal_type.map((item) => {
                                            let filterData = formik.values.goal.type.filter((item2) => item2.serial === item.serial);
                                            if (filterData.length > 0) {
                                                arrayFilter.push({
                                                    ...item,
                                                    is_default: filterData.length > 0,
                                                })
                                            } else {
                                                arrayFilter.push({
                                                    ...item,
                                                    is_default: false,
                                                })
                                            }
                                        })
                                        formik.setFieldValue('goal.type', arrayFilter)
                                    }
                                }
                            })
                        }
                        if (formik.values.evaluationComponent[1].selected && (activeStep >= lastState || change)) {
                            adminService.listEvaluationJoruneyCompetencyTemplate(formik.values.cycle).then((rs) => {
                                if (rs.success) {
                                    setFirstCompetencyTemplate(true)
                                    setFirstProbationCompetencyTemplate(true)
                                    if (formik.values.competency.competencyType.length === 0) {
                                        let competencyList = rs.data.competency_type.map((item) => {
                                            return {
                                                selected: false,
                                                name: item.name,
                                                serial: item.serial,
                                                ratio: '',
                                            }
                                        })
                                        formik.setFieldValue('competency.competencyType', competencyList);
                                    } else {
                                        if (rs.data.competency_type.length !== formik.values.competency.competencyType.length) {
                                            let arrayFilter = [];
                                            rs.data.competency_type.map((item) => {
                                                let filterData = formik.values.competency.competencyType.filter((data) => data.serial === item.serial);
                                                if (filterData.length > 0) {
                                                    arrayFilter.push({
                                                        selected: filterData.length > 0,
                                                        name: item.name,
                                                        ratio: filterData[0].ratio,
                                                        serial: item.serial,
                                                        ...item
                                                    })
                                                } else {
                                                    arrayFilter.push({
                                                        selected: false,
                                                        name: item.name,
                                                        serial: item.serial,
                                                        ratio: '',
                                                    })
                                                }
                                            })
                                            formik.setFieldValue('competency.competencyType', arrayFilter)
                                        }
                                    }
                                }
                            })
                        }

                        const evaluationForm = formik.values.evaluationComponent.filter((item) => item.selected).map((data) => {
                            return { selected: false, componentName: data.componentName, ratio: '', required: { employee: false, evaluator: false }, type: data.type }
                        })
                        if (formik.values.pr && parseInt(formik.values.prTemplate) > 0) {
                            let ObjectData = formik.values.prTemplateList;
                            if (ObjectData === undefined || ObjectData === null || ObjectData?.length === 0) {
                                setFirstPrTemplate(true)
                                ObjectData = Array.from({ length: formik.values.prTemplate }, (_, i) => {
                                    return {
                                        isOpen: i === 0,
                                        nameEn: '',
                                        nameTh: '',
                                        descriptionEn: '',
                                        descriptionTh: '',
                                        evaluationType: '',
                                        scoreDecimal: '',
                                        workflow: '',
                                        idp: false,
                                        idpTemplate: '',
                                        promotion: false,
                                        evaluationComponent: evaluationForm,
                                        previewWorkflow: [],
                                    }
                                })
                            } else if (ObjectData?.length > parseInt(formik.values.prTemplate)) {
                                setFirstPrTemplate(true)
                                let removeCount = ObjectData?.length - parseInt(formik.values.prTemplate);
                                for (let o = 0; o < removeCount; o++) {
                                    ObjectData.pop()
                                }
                            } else if (ObjectData?.length < parseInt(formik.values.prTemplate)) {
                                setFirstPrTemplate(true)
                                let addCount = parseInt(formik.values.prTemplate) - ObjectData?.length;
                                for (let o = 0; o < addCount; o++) {
                                    ObjectData.push({
                                        isOpen: false,
                                        nameEn: '',
                                        nameTh: '',
                                        descriptionEn: '',
                                        descriptionTh: '',
                                        evaluationType: '',
                                        scoreDecimal: '',
                                        workflow: '',
                                        idp: false,
                                        idpTemplate: '',
                                        promotion: false,
                                        evaluationComponent: evaluationForm,
                                        previewWorkflow: [],
                                    })
                                }
                            }
                            formik.setFieldTouched('prTemplateList', ObjectData)
                            formik.setFieldValue('prTemplateList', ObjectData)
                        }
                    }
                }
                if (activeStep >= lastState) {
                    setLastState(activeStep)
                }
                if (activeStep === steps.length - 2) {
                    var summaryData = []
                    var dataSummary = [];
                    if (isProbation) {
                        dataSummary = formik.values.probation
                    } else {
                        dataSummary = formik.values
                    }
                    if (dataSummary.goal?.previewWorkflow?.length > 0 && dataSummary.evaluationComponent[0].selected) {
                        const clonePreview = [...dataSummary.goal.previewWorkflow];
                        let firstDate = clonePreview.sort(function (a, b) {
                            return new Date(a.startDate) - new Date(b.startDate);
                        });
                        let lastDate = clonePreview.sort(function (a, b) {
                            return new Date(a.endDate) - new Date(b.endDate);
                        });
                        let preview = {
                            isOpen: true, name: dataSummary.goal.nameEn, startDate: isProbation ? `Employee Start Date` : Util.dateDayFormatAdmin(firstDate[0].startDate), endDate: isProbation ? workflowLastday : Util.dateDayFormatAdmin(lastDate[lastDate.length - 1].endDate), children:
                                clonePreview.map((item => {
                                    return {
                                        name: i18n.language === "th-TH" ? item.description.th : item.description.en,
                                        startDate: isProbation ? `Employee Start Date` : Util.dateDayFormatAdmin(item.startDate),
                                        endDate: isProbation ? workflowLastday : Util.dateDayFormatAdmin(item.endDate),
                                    }
                                }))
                        }
                        summaryData.push(preview)
                    }
                    if (dataSummary.pr) {
                        const prList = [...dataSummary.prTemplateList]
                        prList.map((item) => {
                            const clonePreview = item.previewWorkflow;
                            let firstDate = clonePreview.sort(function (a, b) {
                                return new Date(a.startDate) - new Date(b.startDate);
                            });
                            let lastDate = clonePreview.sort(function (a, b) {
                                return new Date(a.endDate) - new Date(b.endDate);
                            });
                            let preview = {
                                isOpen: true, name: item.nameEn, startDate: Util.dateDayFormatAdmin(firstDate[0].startDate), endDate: Util.dateDayFormatAdmin(lastDate[lastDate.length - 1].endDate), children:
                                    clonePreview.map((preview => {
                                        return {
                                            name: i18n.language === "th-TH" ? preview.description.th : preview.description.en,
                                            startDate: Util.dateDayFormatAdmin(preview.startDate),
                                            endDate: Util.dateDayFormatAdmin(preview.endDate),
                                        }
                                    }))
                            }
                            summaryData.push(preview)
                        })
                    }
                    if (dataSummary.previewWorkflow?.length > 0 && !isProbation) {
                        const clonePreview = [...dataSummary.previewWorkflow];
                        let firstDate = clonePreview.sort(function (a, b) {
                            return new Date(a.startDate) - new Date(b.startDate);
                        });
                        let lastDate = clonePreview.sort(function (a, b) {
                            return new Date(a.endDate) - new Date(b.endDate);
                        });
                        let preview = {
                            isOpen: true, name: dataSummary.nameEn, startDate: Util.dateDayFormatAdmin(firstDate[0].startDate), endDate: Util.dateDayFormatAdmin(lastDate[lastDate.length - 1].endDate), children:
                                clonePreview.map((item => {
                                    return {
                                        name: i18n.language === "th-TH" ? item.description.th : item.description.en,
                                        startDate: Util.dateDayFormatAdmin(item.startDate),
                                        endDate: Util.dateDayFormatAdmin(item.endDate),
                                    }
                                }))
                        }
                        summaryData.push(preview)
                    }
                    if (!isProbation) {
                        formik.setFieldValue('summary', summaryData)
                    } else if (isProbation) { //probation
                        const clonePreview = [...dataSummary.previewWorkflow];
                        const dataWithoutExtend = [...dataSummary.previewWorkflow].filter((item) => item.type !== 'extend')
                        var summaryList = [];
                        let preview2 = {
                            isOpen: true, name: dataSummary.nameEn, startDate: 'Employee Start Date', endDate: ` ${dataWithoutExtend[dataWithoutExtend.length - 1].duration} Days From Start Date`, children: []
                        }
                        setWorkflowLastday(`${dataWithoutExtend[dataWithoutExtend.length - 1].duration} Days From Start Date`)
                        dataWithoutExtend.map((item => {
                            item.steps.map((data) => {
                                summaryList.push({
                                    name: i18n.language === "th-TH" ? data.description.th : data.description.en,
                                    startDate: 'Employee Start Date',
                                    endDate: `${item.duration} days from Start Date`
                                })
                            })
                        }))
                        preview2.children = summaryList;
                        summaryData.push(preview2)
                        formik.setFieldValue('probation.summary', summaryData)
                    }
                }
                if (activeStep !== 0 || (activeStep === 0 && lastState > 0)) {
                    handleNext()
                }
            } else {
                // submit(values)
            }
            // openSuccessAddDialog(true)
        },
        handleBlur: (v) => {
        }
    });
    useEffect(() => {
        adminService.listEvaluationJoruneyCycle().then((rs) => {
            if (rs.success) {
                setCycleList(rs.data.cycles)
                formik.setFieldValue("cycle", Util.formatData(state?.cycleID, ""))
                setCycleType(Util.formatData(rs.data?.cycles.filter((item) => item.serial === state?.cycleID)[0]?.type, ""))
                if (state?.cycleID) {
                    const isProb = rs.data.cycles.find((item) => item.serial === state?.cycleID)
                    setCycleType(Util.formatData(isProb?.type, ""))
                    if (isProb?.options?.is_probation) {
                        setIsProbation(true)
                    } else {
                        setIsProbation(false)
                    }
                }
            }
        })

        if (state?.serial) {
            adminService.getEvaluatiionJourney(state.serial).then((rs) => {
                if (rs.data.success) {
                    setOldData(rs.data.data)
                    mappingDataFromGet(rs.data.data)
                    setCycleType(rs.data.data?.cycle?.type)
                }
            })
        }
    }, []);

    useEffect(() => {
        const el = document.querySelector('.Mui-error, [data-error]');
        (el?.parentElement ?? el)?.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }, [formik?.isSubmitting])

    const mappingDataFromGet = (data) => {
        setIsUsed(data.is_used ?? false)
        setLaunchForm(data.is_used ?? false)
        setIsProbation(data.is_probation ?? false)
        const evaluatorData = data.evaluate_journey_data;
        const goalData = evaluatorData.evaluate_goal_template;
        const competencyData = evaluatorData.evaluate_competency_template;
        var evaluateLists = evaluatorData.evaluation_component.map((item) => {
            let selected = parseFloat(item.ratio ?? 0) > 0
            if (!selected && item.type === 'custom' && item?.lists?.length > 0 && item.lists[0].custom_form) {
                selected = true
            }

            return {
                selected: selected,//parseFloat(item.ratio ?? 0) > 0,
                total: item.total,
                componentName: item.type,
                lists: item.lists.map((list) => {
                    return {
                        allow_evaluate: list.allow_evaluate,
                        ratio: list.ratio,
                        requied_custom: (item.type == 'custom' || item.type == 'probation') ? true : false,
                        custom_form: list.custom_form,
                        required: {
                            employee: list.require_employee_comment,
                            evaluator: list.require_evaluator_comment
                        }
                    }
                })

            }
        })
        let mergeLists = [];
        evaluateLists.forEach((item) => {
            var existing = mergeLists.filter((v, i) => {
                return v.componentName == item.componentName;
            });
            if (existing.length) {
                var existingIndex = mergeLists.indexOf(existing[0]);
                mergeLists[existingIndex].lists = mergeLists[existingIndex].lists.concat(item.lists);
            } else {
                mergeLists.push(item);
            }
        });
        var dataMapping = {
            code: type === 'duplicate' ? '' : data.code,
            cycle: data.cycle?.serial,
            statusActive: data.status === 'active',
            nameEn: evaluatorData?.name_en,
            nameTh: evaluatorData?.name_th,
            descriptionEn: evaluatorData?.description_en,
            descriptionTh: evaluatorData?.description_th,
            evaluationType: evaluatorData?.evaluation_type?.serial,
            scoreDecimal: evaluatorData?.total_score,
            workflow: evaluatorData?.workflow?.workflow_data?.id,
            idp: (evaluatorData.others_component?.idp?.idp_template_selected?.serial !== undefined && evaluatorData.others_component?.idp?.idp_template_selected?.serial !== null),
            idpTemplate: evaluatorData.others_component?.idp?.idp_template_selected?.serial,
            promotion: evaluatorData.others_component?.promotion_preparation,
            pr: data?.pr_data?.length > 0,
            prTemplate: data?.pr_data?.length,
            serial: data.serial,
            serialEvaluate: evaluatorData?.serial,
            ratingScale: evaluatorData?.goal_scale?.serial ?? '',
            expectRating: evaluatorData?.expected_rating?.serial ?? '',
            is_enforce_start: evaluatorData?.is_enforce_start ?? false,
            allow_evaluator_edit_goal: evaluatorData?.allow_evaluator_edit_goal ?? false,
            prTemplateList: data?.pr_data?.map((item, i) => {
                return {
                    previewWorkflow: item.workflow.workflow_data.steps.map((step) => {
                        return {
                            serial: step.id,
                            seq: step.step,
                            action: step.action,
                            field: step.fields,
                            description: step.description,
                            startDate: step.startDate ? step.startDate.split('/')[1] + '/' + step.startDate.split('/')[0] + '/' + step.startDate.split('/')[2] : null,
                            endDate: step.endDate ? step.endDate.split('/')[1] + '/' + step.endDate.split('/')[0] + '/' + step.endDate.split('/')[2] : null,
                            options: step.options,
                            is_send_mail: step.is_send_mail
                        }
                    }),
                    chooseWorkflow: item.workflow.workflow_data,
                    workflow: item.workflow.workflow_data.id,
                    isOpen: i === 0,
                    nameEn: item.name_en,
                    nameTh: item.name_th,
                    descriptionEn: item.description_en,
                    descriptionTh: item.description_th,
                    evaluationType: item.evaluation_type?.serial,
                    scoreDecimal: item.score_decimal,
                    // idp: item.others_component?.idp ? Object.keys(item.others_component?.idp?.idp_template_selected).length > 0 : false,
                    idp: false,
                    idpTemplate: item.others_component?.idp?.idp_template_selected?.serial,
                    promotion: item.others_component?.promotion_preparation,
                    evaluationComponent: item.evaluation_component?.map((eva) => {
                        return {
                            selected: eva.status === 'active',
                            ratio: eva.ratio,
                            total: eva.total,
                            componentName: eva.type,
                            required: {
                                employee: eva.require_employee_comment,
                                evaluator: eva.require_evaluator_comment
                            }
                        }
                    }),
                }
            }),
            evaluationComponent: mergeLists,
            total: 100,
            chooseWorkflow: evaluatorData?.workflow?.workflow_data,
            previewWorkflow: evaluatorData?.workflow?.workflow_data.steps.map((item) => {
                return {
                    serial: item.id,
                    seq: item.step,
                    action: item.action,
                    field: item.fields,
                    description: item.description,
                    startDate: item.startDate ? item.startDate.split('/')[1] + '/' + item.startDate.split('/')[0] + '/' + item.startDate.split('/')[2] : null,
                    endDate: item.endDate ? item.endDate.split('/')[1] + '/' + item.endDate.split('/')[0] + '/' + item.endDate.split('/')[2] : null,
                    options: item.options,
                    is_send_mail: item.is_send_mail
                }
            }),
            summary: []
        }
        Object.assign(dataMapping, {
            competency: {
                nameEn: competencyData?.name_en ?? '',
                nameTh: competencyData?.name_th ?? '',
                descriptionEn: competencyData?.description_en ?? '',
                descriptionTh: competencyData?.description_th ?? '',
                total: competencyData ? 100 : 0,
                competencyType: competencyData?.competency_type?.map((item) => {
                    return {
                        selected: item.status === 'active',
                        name: item.name,
                        ratio: item.weight,
                        ...item
                    }
                }) ?? []
            },
        })
        Object.assign(dataMapping, {
            goal: {
                nameEn: goalData?.name_en ?? '',
                nameTh: goalData?.name_th ?? '',
                descriptionEn: goalData?.description_en ?? '',
                descriptionTh: goalData?.description_th ?? '',
                workflow: goalData?.workflow?.workflow_data?.id ?? '',
                total: goalData ? 100 : 0,
                goalCategory: goalData?.goal_category?.map((item) => {
                    return {
                        selected: true,
                        name: item.name,
                        serial: item.serial,
                        ratio: item.weight,
                        ...item,
                    }
                }) ?? [],
                chooseWorkflow: goalData?.workflow?.workflow_data,
                previewWorkflow: goalData?.workflow?.workflow_data?.steps?.map((item) => {
                    return {
                        serial: item.id,
                        seq: item.step,
                        action: item.action,
                        field: item.fields,
                        description: item.description,
                        startDate: item.startDate ? item.startDate.split('/')[1] + '/' + item.startDate.split('/')[0] + '/' + item.startDate.split('/')[2] : null,
                        endDate: item.endDate ? item.endDate.split('/')[1] + '/' + item.endDate.split('/')[0] + '/' + item.endDate.split('/')[2] : null,
                        options: item.options,
                        is_send_mail: item.is_send_mail
                    }
                }) ?? [],
                goalLibrary: goalData?.goal_library?.serial ?? '',
                goalGroup: goalData?.goal_progress_group?.serial ?? '',
                goalProgress: goalData?.goal_progress_group?.goal_progress_data?.map((item) => {
                    return {
                        seq: item.seq,
                        name: item.name,
                        nameEn: item.name_en,
                        nameTh: item.name_th,
                        color: JSON.parse(item.color),
                        serial: item.id,
                        selected: item.is_default
                    }
                }) ?? [],
                scaleMapping: goalData?.scale ?? '',
                ratingScale: goalData?.goal_scale?.serial ?? '',
                expectRating: goalData?.expected_rating?.serial ?? '',//goalData?.expected_rating?.serial ?? '',
                ratingScaleList: goalData?.goal_scale?.rating_scale?.map((item) => {
                    return {
                        selected: true,
                        ...item,
                        descriptionEn: item.description_en,
                        descriptionTh: item.description_th,
                    }
                }) ?? [],
                type: goalData?.goal_type.map((item) => {
                    return {
                        ...item,
                        is_default: true,
                    }
                }) ?? ''
            }
        })
        let ratingScaleList = goalData?.goal_scale?.rating_scale?.map((item) => {
            return {
                scaleLevel: item.level,
                value: item.value,
                descriptionEn: item.description_en,
                descriptionTh: item.description_th,
                serial: item.serial
            }
        }) ?? []
        setExpectRating(ratingScaleList)
        if (data.is_probation) {
            count = 1;
            dispatch(getWorkflow(evaluatorData?.workflow?.workflow_data?.id)).then(resp => {
                let workflow = resp?.workflow ?? null
                let workflow_preview = workflow.sections.filter((data) => data.status === 'active')
                let workflow_data_choose = workflow;
                if (workflow) {
                    dataMapping.chooseWorkflow = workflow_data_choose;
                    dataMapping.previewWorkflow = workflow_preview;
                }
            })
            formik.setValues(dataMapping)
            formik.setFieldValue('code', dataMapping.code)
            formik.setFieldValue('cycle', dataMapping.cycle)
            formik.setFieldValue('serial', dataMapping.serial)
            formik.setFieldValue('serialEvaluate', dataMapping.serialEvaluate)
            formik.setFieldValue('probation', dataMapping)
        } else {
            console.log('dataMapping', dataMapping)
            formik.setValues(dataMapping)
        }
    }

    useEffect(() => {
        if (calType === 'evaluation') {
            if (calIdx >= 0 && formik.values.prTemplateList?.length > 0 && formik.values.prTemplateList[calIdx]) {
                let total = formik.values.prTemplateList[calIdx].evaluationComponent.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0).toFixed(2)
                formik.setFieldValue(`prTemplateList[${calIdx}].total`, parseFloat(total))
            } else {
                let total = 0;
                formik.values.evaluationComponent.map((item) => {
                    total += item.lists.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0)
                })
                formik.setFieldValue('total', parseFloat(total))
            }
        } else if (calType === 'probation.evaluation') {
            let total = 0;
            formik.values.probation.evaluationComponent.map((item) => {
                total += item.lists.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0)
            })
            formik.setFieldValue('probation.total', parseFloat(total))
        } else if (calType === 'goal') {
            let total = formik.values.goal.goalCategory.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0).toFixed(2)
            formik.setFieldValue('goal.total', parseFloat(total))
        } else if (calType === 'probation.goal') {
            let total = formik.values.probation.goal.goalCategory.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0).toFixed(2)
            formik.setFieldValue('probation.goal.total', parseFloat(total))
        } else if (calType === 'competency') {
            let total = formik.values.competency.competencyType.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0).toFixed(2)
            formik.setFieldValue('competency.total', parseFloat(total))
        } else if (calType === 'probation.competency') {
            let total = formik.values.probation.competency.competencyType.reduce((sum, value) => parseFloat(sum) + parseFloat(value.ratio === '' ? 0 : value.ratio), 0).toFixed(2)
            formik.setFieldValue('probation.competency.total', parseFloat(total))
        }
    }, [calField, calTotal])
    const handleSubmit = () => {
        if (firstEvaTemplate) {
            setFirstEvaTemplate(false)
        }
        if (firstPrTemplate && steps[activeStep] === t('admin.inputForm.performanceReview')) {
            setFirstPrTemplate(false)
        }
        if (firstGoalTemplate && steps[activeStep] === t('admin.inputForm.goalTemplate')) {
            setFirstGoalTemplate(false)
        }
        if (firstProbationGoalTemplate && steps[activeStep] === t('admin.inputForm.goalProbationTemplate')) {
            setFirstProbationGoalTemplate(false)
        }
        if (firstCompetencyTemplate && steps[activeStep] === t('admin.inputForm.competencyTemplate')) {
            setFirstCompetencyTemplate(false)
        }
        if (firstProbationCompetencyTemplate && steps[activeStep] === t('admin.inputForm.competencyProbationTemplate')) {
            setFirstProbationCompetencyTemplate(false)
        }
        formik.submitForm()
    }
    const handleCancel = () => {
        setDiscardDialog(true)
    }

    const [openFailedMessageDialog, setFailedMessageDialog] = React.useState(false);
    const [isSuccessAddDialogOpen, openSuccessAddDialog] = React.useState(false);
    const [discardDialog, setDiscardDialog] = React.useState(false);
    const [isSuccessOpen, openSuccessOpen] = React.useState(false);

    const handleSuccess = () => {
        openSuccessOpen(false);
        clickLink('/admin/evaluation-journey');
    };
    const handleOpenFailedMessageDialog = (value) => {
        setFailedMessageDialog(true);
    };
    const handleCloseFailedMessageDialog = (value) => {
        setFailedMessageDialog(false);
    };
    const handleDiscardDialog = (value) => {
        setDiscardDialog(value)
    };
    const handleDiscardChangeConfirm = () => {
        handleDiscardDialog(false)
        clickLink('/admin/evaluation-journey')
        // navigate('/admin/goal-component', { replace: false });
    };
    const handleDirect = () => {
        openSuccessAddDialog(false)
        navigate('/admin/evaluation-journey', { replace: false });
    }

    const addDate = (date, days) => {
        var result = new Date(date);
        result.setDate(result.getDate() + days);
        return result;
    }

    const createJourney = () => {
        let data = {};
        if (isProbation) {
            data = JSON.parse(JSON.stringify(formik.values.probation));
        } else {
            data = JSON.parse(JSON.stringify(formik.values));
        }
        data.chooseWorkflow.steps = data.chooseWorkflow?.steps?.map((steps) => {
            return data.previewWorkflow.filter((item) => {
                if (item.serial === (steps.id ?? steps.serial)) {
                    item.startDate = item.startDate ? item.startDate.split('/')[1] + '/' + item.startDate.split('/')[0] + '/' + item.startDate.split('/')[2] : null;
                    item.endDate = item.endDate ? item.endDate.split('/')[1] + '/' + item.endDate.split('/')[0] + '/' + item.endDate.split('/')[2] : null;
                    return {
                        ...item,
                    }
                }
            })[0]
        })
        console.log('create journey', data)

        let requestData = {
            code: formik.values.code,
            serial: data.serial ?? '',
            cycle: {
                serial: formik.values.cycle
            },
            status: data.statusActive ? 'active' : 'inactive',
            evaluate_journey_data: {
                name_th: data.nameTh,
                name_en: data.nameEn,
                description_th: data.descriptionTh,
                description_en: data.descriptionEn,
                evaluation_type: {
                    serial: data.evaluationType
                },
                total_score: data.scoreDecimal,
                others_component: {},
                workflow: {
                    workflow_data: data.chooseWorkflow
                },
                expected_rating: {
                    serial: data.expectRating
                },
                is_enforce_start: data.is_enforce_start,
                allow_evaluator_edit_goal: data.allow_evaluator_edit_goal ?? false,
                evaluation_component: data.evaluationComponent.filter((item) => item.selected).map((item) => {
                    return {
                        total: data.total,
                        lists: item.lists.map((list) => {
                            return {
                                ratio: list.ratio,
                                allow_evaluate: list.allow_evaluate,
                                custom_form: list.custom_form,
                                requied_custom: (item.componentName == 'custom' || item.componentName == 'probation') ? true : false,
                                require_employee_comment: list.required.employee,
                                require_evaluator_comment: list.required.evaluator,
                            }
                        }),
                        type: item.componentName,
                    }
                }),
                goal: data.evaluationComponent[0].selected,
                competency: data.evaluationComponent[1].selected,
                is_pr: data.pr,
                serial: data.serialEvaluate ?? '',
            }
        }
        if (data.idp && data.idpTemplate) {
            Object.assign(requestData.evaluate_journey_data.others_component, {
                idp: {
                    idp_template_selected: {
                        serial: data.idpTemplate
                    }
                },
            })
        }
        if (data.promotion) {
            Object.assign(requestData.evaluate_journey_data.others_component, {
                promotion_preparation: data.promotion,
            })
        }
        if (data.pr) {
            Object.assign(requestData.evaluate_journey_data.others_component, {
                performance_review: parseInt(data.prTemplate),
            });
            var performanceList = data.prTemplateList.map((item) => {
                if (item.chooseWorkflow?.steps !== undefined) {
                    item.chooseWorkflow.steps = item.chooseWorkflow?.steps?.map((steps) => {
                        return item.previewWorkflow.filter((item2) => {
                            if (item2.serial === (steps.serial ?? steps.id)) {
                                item2.startDate = item2.startDate ? item2.startDate.split('/')[1] + '/' + item2.startDate.split('/')[0] + '/' + item2.startDate.split('/')[2] : null;
                                item2.endDate = item2.endDate ? item2.endDate.split('/')[1] + '/' + item2.endDate.split('/')[0] + '/' + item2.endDate.split('/')[2] : null;
                                return {
                                    ...item2,
                                }
                            }
                        })[0]
                    })
                }

                let buildObject = {
                    name_th: item.nameTh,
                    name_en: item.nameEn,
                    description_th: item.descriptionTh,
                    description_en: item.descriptionEn,
                    evaluation_type: {
                        serial: item.evaluationType
                    },
                    total_score: item.scoreDecimal,
                    others_component: {},
                    workflow: {
                        workflow_data: item.chooseWorkflow
                    },
                    evaluation_component: data.evaluationComponent.filter((item) => item.selected).map((item) => {
                        return {
                            total: data.total,
                            lists: item.lists.map((list) => {
                                return {
                                    ratio: list.ratio,
                                    allow_evaluate: list.allow_evaluate,
                                    custom_form: list.custom_form,
                                    requied_custom: (item.componentName == 'custom' || item.componentName == 'probation') ? true : false,
                                    require_employee_comment: list.required.employee,
                                    require_evaluator_comment: list.required.evaluator,
                                }
                            }),
                            type: item.componentName,
                        }
                    }),
                    goal: data.evaluationComponent[0].selected ?? undefined,
                    competency: data.evaluationComponent[1]?.selected ?? undefined,
                    // is_pr: item.pr ?? undefined,
                }
                if (item.idpTemplate) {
                    Object.assign(buildObject.others_component, {
                        idp: {
                            idp_template_selected: {
                                serial: item.idpTemplate ?? undefined
                            }
                        },
                    })
                }
                if (item.promotion) {
                    Object.assign(buildObject.others_component, {
                        promotion_preparation: item.promotion ?? undefined,
                    })
                }

                if (item.serial) buildObject.serial = item.serial

                return buildObject
            })

            Object.assign(requestData, {
                pr_data: performanceList,
            })
        }
        if (data.evaluationComponent[0].selected) {
            data.goal.chooseWorkflow.steps = data.goal?.chooseWorkflow?.steps?.map((steps) => {
                return data.goal.previewWorkflow.filter((item) => {
                    if (item.serial === steps.id) {
                        item.startDate = item.startDate ? item.startDate.split('/')[1] + '/' + item.startDate.split('/')[0] + '/' + item.startDate.split('/')[2] : null;
                        item.endDate = item.endDate ? item.endDate.split('/')[1] + '/' + item.endDate.split('/')[0] + '/' + item.endDate.split('/')[2] : null;
                        return item
                    }
                })[0]
            })
            let goalData = {
                name_th: data.goal.nameTh,
                name_en: data.goal.nameEn,
                description_th: data.goal.descriptionTh,
                description_en: data.goal.descriptionEn,
                workflow: {
                    workflow_data: data.goal.chooseWorkflow
                },
                goal_category: data.goal.goalCategory.filter((item) => item.selected).map((item) => {
                    return {
                        serial: item.serial,
                        name: item.name,
                        weight: item.ratio,
                        total: data.goal.total
                    }
                }),
                goal_type: data.goal.type.filter((item) => item.is_default),
                goal_progress_group: {
                    serial: data.goal.goalGroup
                },
                goal_library: {
                    serial: data.goal.goalLibrary
                },
                scale: data.goal.ratingScale ? true : false,
                is_actual_scale_mapping: true, //data.goal.scaleMapping,
                expected_rating: {
                    serial: data.goal.expectRating
                },
                goal_scale: {
                    serial: data.goal.ratingScale,
                    rating_scale: data.goal.ratingScaleList.map((item) => {
                        return {
                            serial: item.serial
                        }
                    })
                }
            }
            Object.assign(requestData.evaluate_journey_data, {
                evaluate_goal_template: goalData
            })
        }
        if (data.evaluationComponent[1].selected) {
            let competencyData = {
                name_th: data.competency.nameTh,
                name_en: data.competency.nameEn,
                description_th: data.competency.descriptionTh,
                description_en: data.competency.descriptionEn,
                competency_type: data.competency.competencyType.filter((data) => data.selected).map((item) => {
                    return {
                        ...item,
                        serial: item.serial,
                        name: item.name,
                        weight: parseInt(item.ratio),
                        total: data.competency.total,
                    }
                })
            }
            Object.assign(requestData.evaluate_journey_data, {
                evaluate_competency_template: competencyData
            });
        }
        console.log('json to send', requestData)
        if (type === 'edit') {
            adminService.updateEvaluatiionJourney(state.serial, requestData).then((resp) => {
                if (resp.success) {
                    openSuccessOpen(true)
                }
            })
        } else {
            adminService.createEvaluationJourney(requestData).then((resp) => {
                if (resp.success) {
                    openSuccessOpen(true)
                }
            })
        }
    }

    const expanded = (val, field) => {
        formik.setFieldValue(field, val)
    }

    const expandedPr = (val, field, idx) => {
        const prList = formik.values.prTemplateList.map((item) => item.isOpen = false);
        formik.setFieldValue(field, val)
        setTimeout(() => {
            const anchor = document.querySelector(
                `#expanded-${idx}`
            );

            if (anchor) {
                anchor.scrollIntoView({ behavior: "smooth", block: "center" });
            }
        }, 500)
    }

    const formikChange = (val, field, options) => {
        if (field === 'workflow' || options) {
            let workflow_preview = workflowList.filter((item) => item.serial === val.target.value)[0].workflow_data.steps.filter((data) => data.status === 'active')
            let workflow_data_choose = workflowList.filter((item) => item.serial === val.target.value)[0].workflow_data;
            let filterWorkflow = workflow_preview.map((item) => {
                let dataFilter = {
                    serial: item.id,
                    seq: item.step,
                    action: item.action,
                    field: item.fields,
                    description: item.description,
                    startDate: item.startDate ?? null,
                    endDate: item.endDate ?? null,
                    options: item.options,
                    is_send_mail: item.is_send_mail
                }
                return dataFilter
            })
            if (field === 'workflow') {
                formik.setFieldValue('chooseWorkflow', workflow_data_choose)
                formik.setFieldValue('previewWorkflow', filterWorkflow)
            } else if (options) {
                formik.setFieldValue(`${options}.chooseWorkflow`, workflow_data_choose)
                formik.setFieldValue(`${options}.previewWorkflow`, filterWorkflow)
            }
        } else if (field === 'probation.workflow') {
            count = 1;
            dispatch(getWorkflow(val.target.value)).then(resp => {
                let workflow = resp?.workflow ?? null
                let workflow_preview = workflow.sections.filter((data) => data.status === 'active')
                let workflow_data_choose = workflow;
                if (workflow) {
                    formik.setFieldValue('probation.chooseWorkflow', workflow_data_choose)
                    formik.setFieldValue('probation.previewWorkflow', workflow_preview)
                }
            })
        }
        if (field === 'goal.workflow') {
            let workflow_preview = goalWorkflowList.filter((item) => item.serial === val.target.value)[0].workflow_data.steps.filter((data) => data.status === 'active')
            let filterWorkflow = workflow_preview.map((item) => {
                return {
                    serial: item.id,
                    seq: item.step,
                    action: item.action,
                    field: item.fields,
                    description: item.description,
                    startDate: item.startDate ?? null,
                    endDate: item.endDate ?? null,
                    options: item.options,
                    is_send_mail: item.is_send_mail
                }
            })
            let goal_workflow_data_choose = goalWorkflowList.filter((item) => item.serial === val.target.value)[0].workflow_data;
            if (field === 'goal.workflow') {
                formik.setFieldValue('goal.chooseWorkflow', goal_workflow_data_choose)
                formik.setFieldValue('goal.previewWorkflow', filterWorkflow)
            }
        } else if (field === 'probation.goal.workflow') {
            let workflow_preview = goalWorkflowList.filter((item) => item.serial === val.target.value)[0].workflow_data.steps.filter((data) => data.status === 'active')
            let filterWorkflow = workflow_preview.map((item) => {
                return {
                    serial: item.id,
                    seq: item.step,
                    action: item.action,
                    field: item.fields,
                    description: item.description,
                    startDate: item.startDate ?? null,
                    endDate: item.endDate ?? null,
                    options: item.options,
                    is_send_mail: item.is_send_mail
                }
            })
            let goal_workflow_data_choose = goalWorkflowList.filter((item) => item.serial === val.target.value)[0].workflow_data;
            if (field === 'probation.goal.workflow') {
                formik.setFieldValue('probation.goal.chooseWorkflow', goal_workflow_data_choose)
                formik.setFieldValue('probation.goal.previewWorkflow', filterWorkflow)
            }
        }
        if (field === 'goal.goalGroup') {
            let goalGroupColor = goalProgress.filter((item) => item.serial === val.target.value)[0].goal_progress_data;
            let goalGroupProgress = goalGroupColor.map((item) => {
                return {
                    seq: item.seq,
                    name: item.name,
                    nameTh: item.name_th,
                    nameEn: item.name_en,
                    color: JSON.parse(item.color),
                    serial: item.serial,
                    selected: item.is_default
                }
            })
            formik.setFieldValue('goal.goalProgress', goalGroupProgress)
        } else if (field === 'probation.goal.goalGroup') {
            let goalGroupColor = goalProgress.filter((item) => item.serial === val.target.value)[0].goal_progress_data;
            let goalGroupProgress = goalGroupColor.map((item) => {
                return {
                    seq: item.seq,
                    name: item.name,
                    nameTh: item.name_th,
                    nameEn: item.name_en,
                    color: JSON.parse(item.color),
                    serial: item.serial,
                    selected: item.is_default
                }
            })
            formik.setFieldValue('probation.goal.goalProgress', goalGroupProgress)
        }
        if (field === 'goal.ratingScale') {
            let ratingScaleSelect = ratingScale.filter((item) => item.serial === val.target.value)[0].rating_scale;
            let ratingScaleList = ratingScaleSelect.map((item) => {
                return {
                    scaleLevel: item.level,
                    value: item.value,
                    descriptionEn: item.description_en,
                    descriptionTh: item.description_th,
                    serial: item.serial
                }
            })
            setExpectRating(ratingScaleList)
            formik.setFieldValue('goal.ratingScaleList', ratingScaleList)
        } else if (field === 'probation.ratingScale') {
            let ratingScaleSelect = ratingScale.filter((item) => item.serial === val.target.value)[0].rating_scale;
            let ratingScaleList = ratingScaleSelect.map((item) => {
                return {
                    scaleLevel: item.level,
                    value: item.value,
                    descriptionEn: item.description_en,
                    descriptionTh: item.description_th,
                    serial: item.serial
                }
            })
            setEvaExpectRating(ratingScaleList)
            formik.setFieldValue('probation.ratingScaleList', ratingScaleList)
        } else if (field === 'probation.goal.ratingScale') {
            let ratingScaleSelect = ratingScale.filter((item) => item.serial === val.target.value)[0].rating_scale;
            let ratingScaleList = ratingScaleSelect.map((item) => {
                return {
                    scaleLevel: item.level,
                    value: item.value,
                    descriptionEn: item.description_en,
                    descriptionTh: item.description_th,
                    serial: item.serial
                }
            })
            setExpectRating(ratingScaleList)
            formik.setFieldValue('probation.goal.ratingScaleList', ratingScaleList)
        }
        if (field === 'cycle') {
            const isProb = cycleList.find((item) => item.serial === val.target.value)
            setCycleType(Util.formatData(isProb?.type, ""))
            if (isProb?.options?.is_probation) {
                setIsProbation(true)
            } else {
                setIsProbation(false)
            }
        }
        formik.setFieldValue(field, val.target.value)
    }

    const formikChangeGenerateForm = (val, field) => {
        formik.setFieldValue(field, val.target.value)
    }

    const formikChangeCheckbox = (val, field, clear, type, idx, clear2, rowData) => {
        formik.setFieldValue(field, val.target.checked)
        if (clear2) {
            formik.setFieldValue(clear2, [
                {
                    ratio: 0,
                    custom_form: '',
                    requied_custom: rowData?.componentName === 'custom' || rowData?.componentName === 'probation' ? true : false,
                    allow_evaluate: false,
                    required: { employee: false, evaluator: false },
                }
            ])
            formikChangeOnlyNumber({ target: { value: "" } }, clear, type, idx)
        } else if (clear) {
            formikChangeOnlyNumber({ target: { value: "" } }, clear, type, idx)
        }

    }

    const formikChangeOnlyNumber = (val, field, type, idx) => {
        if (val.target.value.indexOf('.') > 0) {
            const idxDot = val.target.value.indexOf('.');
            if (idxDot + 1 === val.target.value.length) {
                formik.setFieldValue(field, val.target.value)
            }
            if (idxDot + 2 === val.target.value.length) {
                formik.setFieldValue(field, parseFloat(val.target.value).toFixed(1))
            }
        } else if (val.target.value === null || val.target.value === "") {
            formik.setFieldValue(field, "")
        } else {
            formik.setFieldValue(field, val.target.value.replace(/[^\d.]|\.(?=.*\.)/g, ''))
        }
        setCalTotal(val.target.value)
        setCalField(field)
        setCalType(type)
        setCalIdx(idx)
    }

    const formikChangeDate = (val, field) => {
        if (val === null || val === "") {
            formik.setFieldValue(field, null)
        } else {
            const date = Util.formatDateForJourney(dayjs(val).format('MM/DD/YYYY'))
            formik.setFieldValue(field, date.split('/')[1] + '/' + date.split('/')[0] + '/' + date.split('/')[2])
        }
    }

    const handleNext = () => {
        gotoTop();
        setActiveStep((prevActiveStep) => prevActiveStep + 1);
    };

    const handleBack = () => {
        gotoTop();
        setActiveStep((prevActiveStep) => prevActiveStep - 1);
    };

    const addCustomForm = (data, evaIdx, listIdx, path) => {
        let evaluationComponent = [...data]
        evaluationComponent[evaIdx].lists.push(
            {
                ratio: 0,
                allow_evaluate: false,
                custom_form: '',
                requied_custom: true,
                required: { employee: false, evaluator: false },
            }
        )
        formik.setFieldValue(path + 'evaluationComponent', evaluationComponent)
    }

    const removeCustomForm = (data, evaIdx, listIdx, path) => {
        let evaluationComponent = [...data]
        evaluationComponent[evaIdx].lists.splice(listIdx, 1);
        formik.setFieldValue(path + 'evaluationComponent', evaluationComponent)
    }

    const IOSSwitch = styled((props) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: "50px !important",
        height: "24px !important",
        padding: "0 !important",
        marginRight: "10px",
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: "4px 6px",
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(22px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: theme.palette.mode === 'dark' ? '#2ECA45' : '#5DA196',
                    opacity: 1,
                    border: 0,
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 1,
                    backgroundColor: '#D8D8D8',
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color:
                    theme.palette.mode === 'light'
                        ? theme.palette.grey[100]
                        : theme.palette.grey[600],
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 1,
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 16,
            height: 16,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: theme.palette.mode === 'light' ? '#C0C0C0' : '#39393D',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
        },
    }));

    const getStepContent = (step) => {
        switch (steps[step]) {
            case t('admin.inputForm.templateCode'):
                return templateForm();
            case t('admin.inputForm.probationTemplate'):
                return probationForm();
            case t('admin.inputForm.evaluationTemplate'):
                return evaluationForm();
            case t('admin.inputForm.performanceReview'):
                return prForm();
            case t('admin.inputForm.goalTemplate'):
                return goalForm();
            case t('admin.inputForm.goalProbationTemplate'):
                return goalProbationForm();
            case t('admin.inputForm.competencyTemplate'):
                return competencyForm();
            case t('admin.inputForm.competencyProbationTemplate'):
                return competencyProbationForm();
            case t('admin.inputForm.evaluationSummary'):
                return summaryForm();
            default:
                return null;
        }
    }

    const showWorkflowTable = (values, errors, touched, pathData, showScore, showReject, showEditable, showMail, checkField, isProbation) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg={12} md={12} xs={12} classes={{ root: classes.evaluationBox }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.previewWorkflow')}</Typography>
                <Table classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'100px'} sx={{ marginLeft: '6px' }}>{t('admin.inputForm.table.header.seq')}</TableCell>
                            <TableCell width={'150px'}>{t('admin.inputForm.table.header.action')}</TableCell>
                            <TableCell width={'150px'}>{t('admin.inputForm.table.header.field')}</TableCell>
                            <TableCell width={'250px'}>{t('admin.inputForm.table.header.description')}</TableCell>
                            <TableCell width={isProbation ? '180px' : '200px'}>{t('admin.inputForm.table.header.startEndDate')}</TableCell>
                            <TableCell width={isProbation ? '50px' : '10px'}></TableCell>
                            <TableCell width={isProbation ? '180px' : '200px'}></TableCell>
                            {showScore && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.hideScore')}</TableCell>}
                            {showReject && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.reject')}</TableCell>}
                            {showEditable && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.editable')}</TableCell>}
                            {showMail && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.email')}</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.previewWorkflow.map((row, idx) => (
                            <TableRow
                                key={idx}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                classes={{ root: classes.tableBodyReview }}
                            >
                                <TableCell>
                                    <Typography sx={{ marginLeft: '6px' }} classes={{ root: classes.checkboxLabel }}>
                                        {row.seq}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {row.action.label}
                                    </Typography>
                                </TableCell>
                                {row.field &&
                                    <TableCell style={row.field.length > 1 ? { borderLeft: '1px solid #e5e5e5', borderRight: '1px solid #e5e5e5', paddingLeft: '9px' } : {}}>
                                        {row.field.map((item, idx) => {
                                            return (<>
                                                <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5 } : { paddingLeft: 0, paddingBottom: 5 }}>
                                                    {item.label}
                                                </Typography>
                                                {item?.value &&
                                                    <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5, color: '#DADADA' } : { paddingLeft: 0, paddingBottom: 5, color: '#DADADA' }}>
                                                        {item.value.name}
                                                    </Typography>
                                                }
                                            </>
                                            )
                                        })}
                                    </TableCell>
                                }
                                <TableCell>
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {row.description.th}
                                    </Typography>
                                    <Typography classes={{ root: classes.checkboxLabel }} style={{ fontSize: '14px' }}>
                                        {row.description.en}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {isProbation
                                        ?
                                        <Typography classes={{ root: classes.checkboxLabel }}>
                                            {`Employee Start Date`}
                                        </Typography>
                                        :
                                        <>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} classes={{ root: classes.inputDateSize }}>
                                                <DesktopDatePicker
                                                    format="dd/MM/yyyy"
                                                    value={row.startDate}
                                                    onChange={e => formikChangeDate(e, `${pathData + 'previewWorkflow[' + idx + '].startDate'}`)}
                                                    // onChange={(newValue) => {
                                                    // if(newValue) {
                                                    //     setStartDate(Util.formatDate(newValue));
                                                    // } else {
                                                    //     setStartDate(null)
                                                    // }
                                                    // }}
                                                    disabled={launchForm}
                                                    classes={launchForm ? { root: classes.inputTopicDisabled } : { root: classes.inputDate }}
                                                    inputProps={{
                                                        placeholder: t("mygoal.placeholder.startDate"), sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA"
                                                            },
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        error={(row.startDate === "" || row.startDate === null) && !checkField}
                                                        classes={launchForm ? { root: classes.inputTopicDisabled } : { root: classes.inputDate }}
                                                        size="small"
                                                    />
                                                    }
                                                />
                                            </LocalizationProvider>
                                            {(row.startDate === "" || row.startDate === null) && !checkField ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseFill')} </FormHelperText>) : <></>}
                                        </>
                                    }
                                </TableCell>
                                <TableCell>
                                    <Typography classes={{ root: classes.textShowSmall }}>
                                        -
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    {isProbation
                                        ?
                                        <Typography classes={{ root: classes.checkboxLabel }}>
                                            {workflowLastday}
                                        </Typography>
                                        :
                                        <>
                                            <LocalizationProvider dateAdapter={AdapterDateFns} classes={{ root: classes.inputDateSize }}>
                                                <DesktopDatePicker
                                                    format="dd/MM/yyyy"
                                                    value={row.endDate}
                                                    minDate={addDate(row.startDate, 0)}
                                                    onChange={e => formikChangeDate(e, `${pathData + 'previewWorkflow[' + idx + '].endDate'}`)}
                                                    // onChange={(newValue) => {
                                                    // if(newValue) {
                                                    //     setStartDate(Util.formatDate(newValue));
                                                    // } else {
                                                    //     setStartDate(null)
                                                    // }
                                                    // }}
                                                    disabled={launchForm}
                                                    classes={launchForm ? { root: classes.inputTopicDisabled } : { root: classes.inputDate }}
                                                    inputProps={{
                                                        placeholder: t("mygoal.placeholder.endDate"), sx: {
                                                            "&::placeholder": {
                                                                color: "#AAAAAA"
                                                            }
                                                        }
                                                    }}
                                                    renderInput={(params) => <TextField {...params}
                                                        error={(row.endDate === "" || row.endDate === null) && !checkField}
                                                        classes={launchForm ? { root: classes.inputTopicDisabled } : { root: classes.inputDate }}
                                                        size="small"
                                                    />
                                                    }
                                                />
                                            </LocalizationProvider>
                                            {(row.endDate === "" || row.endDate === null) && !checkField ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseFill')} </FormHelperText>) : <></>}
                                        </>
                                    }
                                </TableCell>
                                {showScore &&
                                    <TableCell align='center'>
                                        {row?.options?.hide_score_self !== undefined &&
                                            <Checkbox
                                                disabled
                                                classes={{ root: classes.checkBoxForShow }}
                                                checked
                                            />
                                        }
                                    </TableCell>
                                }
                                {showReject &&
                                    <TableCell align='center'>
                                        {row?.options?.reject !== undefined &&
                                            <Checkbox
                                                disabled
                                                classes={{ root: classes.checkBoxForShow }}
                                                checked
                                            />
                                        }
                                    </TableCell>
                                }
                                {showEditable &&
                                    <TableCell align='center'>
                                        {row?.options?.edit !== undefined &&
                                            <Checkbox
                                                disabled
                                                classes={{ root: classes.checkBoxForShow }}
                                                checked
                                            />
                                        }
                                    </TableCell>
                                }
                                {showMail &&
                                    <TableCell align='center'>
                                        {row?.is_send_mail &&
                                            <Checkbox
                                                disabled
                                                classes={{ root: classes.checkBoxForShow }}
                                                checked
                                            />
                                        }
                                    </TableCell>
                                }
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const showStartProbation = (val, idx) => {
        return (
            <TableRow
                key={'header' + idx}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                classes={{ root: classes.tableBodyReview }}
            >
                <TableCell colSpan={10}>
                    <Typography sx={{ marginLeft: '6px', color: '#5DA196' }} classes={{ root: classes.checkboxLabel }}>
                        {val.description.en} ({val.description.th})
                    </Typography>
                    <Typography sx={{ marginLeft: '6px' }} classes={{ root: classes.checkboxLabel }}>
                        End date: {val.duration} Days from Employee Start Date
                    </Typography>
                </TableCell>
            </TableRow>)
    }

    const showProbrartionTable = (values, errors, touched, pathData, showScore, showReject, showEditable, showMail, checkField) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg={12} md={12} xs={12} classes={{ root: classes.evaluationBox }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.previewWorkflow')}</Typography>
                <Table sx={{ borderBottom: '1px solid #E5E5E5' }} classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'100px'} sx={{ marginLeft: '6px' }}>{t('admin.inputForm.table.header.seq')}</TableCell>
                            <TableCell width={'150px'}>{t('admin.inputForm.table.header.action')}</TableCell>
                            <TableCell width={'150px'}>{t('admin.inputForm.table.header.field')}</TableCell>
                            <TableCell width={'250px'}>{t('admin.inputForm.table.header.description')}</TableCell>
                            <TableCell width={'10px'}></TableCell>
                            <TableCell width={'200px'}></TableCell>
                            {showScore && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.hideScore')}</TableCell>}
                            {showReject && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.reject')}</TableCell>}
                            {showEditable && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.editable')}</TableCell>}
                            {showMail && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.email')}</TableCell>}
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.previewWorkflow.map((row, idx) => {
                            return (
                                row.type !== 'extend' &&
                                <>
                                    {showStartProbation(row, idx)}
                                    {row?.steps?.map((data, idx2) => (
                                        <TableRow
                                            key={row.type + idx2}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            classes={{ root: classes.tableBodyReview }}
                                        >
                                            <TableCell>
                                                <Typography sx={{ marginLeft: '6px' }} classes={{ root: classes.checkboxLabel }}>
                                                    {count++}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {data.action.label}
                                                </Typography>
                                            </TableCell>
                                            {data.fields &&
                                                <TableCell style={data?.fields?.length > 1 ? { borderLeft: '1px solid #e5e5e5', borderRight: '1px solid #e5e5e5', paddingLeft: '9px' } : {}}>
                                                    {data?.fields?.map((item, idx) => {
                                                        return (<>
                                                            <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5 } : { paddingLeft: 0, paddingBottom: 5 }}>
                                                                {item.label}
                                                            </Typography>
                                                            {item?.value &&
                                                                <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5, color: '#DADADA' } : { paddingLeft: 0, paddingBottom: 5, color: '#DADADA' }}>
                                                                    {item.value.name}
                                                                </Typography>
                                                            }
                                                        </>
                                                        )
                                                    })}
                                                </TableCell>
                                            }
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {data.description.th}
                                                </Typography>
                                                <Typography classes={{ root: classes.checkboxLabel }} style={{ fontSize: '14px' }}>
                                                    {data.description.en}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                            </TableCell>
                                            <TableCell>
                                            </TableCell>
                                            {showScore &&
                                                <TableCell align='center'>
                                                    {data?.options?.hide_score_self !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showReject &&
                                                <TableCell align='center'>
                                                    {data?.options?.reject !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showEditable &&
                                                <TableCell align='center'>
                                                    {data?.options?.edit !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showMail &&
                                                <TableCell align='center'>
                                                    {data?.is_send_mail &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                        </TableRow>
                                    ))}
                                </>
                            )

                        })}
                    </TableBody>
                </Table>
                {values.previewWorkflow.find((row) => row.type === 'extend') &&
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" mt={3} mb={1} display="flex">{t('admin.inputForm.previewExtend')}</Typography>
                }
                {values.previewWorkflow.find((row) => row.type === 'extend') &&
                    <Table sx={{ borderBottom: '1px solid #E5E5E5' }} classes={{ root: classes.table }}>
                        <TableHead classes={{ root: classes.tableHeadBigger }}>
                            <TableRow>
                                <TableCell width={'100px'} sx={{ marginLeft: '6px' }}>{t('admin.inputForm.table.header.seq')}</TableCell>
                                <TableCell width={'150px'}>{t('admin.inputForm.table.header.action')}</TableCell>
                                <TableCell width={'150px'}>{t('admin.inputForm.table.header.field')}</TableCell>
                                <TableCell width={'250px'}>{t('admin.inputForm.table.header.description')}</TableCell>
                                <TableCell width={'10px'}></TableCell>
                                <TableCell width={'200px'}></TableCell>
                                {showScore && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.hideScore')}</TableCell>}
                                {showReject && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.reject')}</TableCell>}
                                {showEditable && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.editable')}</TableCell>}
                                {showMail && <TableCell width={'100px'} align="center">{t('admin.inputForm.table.header.email')}</TableCell>}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {values.previewWorkflow.map((row, idx) => (
                                row.type === 'extend' &&
                                <>
                                    {row.steps.map((data, idx2) => (
                                        <TableRow
                                            key={row.type + idx2}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            classes={{ root: classes.tableBodyReview }}
                                        >
                                            <TableCell>
                                                <Typography sx={{ marginLeft: '6px' }} classes={{ root: classes.checkboxLabel }}>
                                                    {idx2 + 1}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {data.action.label}
                                                </Typography>
                                            </TableCell>
                                            {data.fields &&
                                                <TableCell style={data?.fields?.length > 1 ? { borderLeft: '1px solid #e5e5e5', borderRight: '1px solid #e5e5e5', paddingLeft: '9px' } : {}}>
                                                    {data?.fields?.map((item, idx) => {
                                                        return (<>
                                                            <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5 } : { paddingLeft: 0, paddingBottom: 5 }}>
                                                                {item.label}
                                                            </Typography>
                                                            {item?.value &&
                                                                <Typography classes={{ root: classes.checkboxLabel }} style={idx > 0 ? { borderTop: '1px solid #e5e5e5', paddingTop: 5, color: '#DADADA' } : { paddingLeft: 0, paddingBottom: 5, color: '#DADADA' }}>
                                                                    {item.value.name}
                                                                </Typography>
                                                            }
                                                        </>
                                                        )
                                                    })}
                                                </TableCell>
                                            }
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {data.description.th}
                                                </Typography>
                                                <Typography classes={{ root: classes.checkboxLabel }} style={{ fontSize: '14px' }}>
                                                    {data.description.en}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                            </TableCell>
                                            <TableCell>
                                            </TableCell>
                                            {showScore &&
                                                <TableCell align='center'>
                                                    {data?.options?.hide_score_self !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showReject &&
                                                <TableCell align='center'>
                                                    {data?.options?.reject !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showEditable &&
                                                <TableCell align='center'>
                                                    {data?.options?.edit !== undefined &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                            {showMail &&
                                                <TableCell align='center'>
                                                    {data?.is_send_mail &&
                                                        <Checkbox
                                                            disabled
                                                            classes={{ root: classes.checkBoxForShow }}
                                                            checked
                                                        />
                                                    }
                                                </TableCell>
                                            }
                                        </TableRow>
                                    ))}
                                </>

                            ))}
                        </TableBody>
                    </Table>
                }
            </Grid>
        </Grid>
    }

    const showEvaluationTable = (values, errors, touched, pathData, index, firstCheck) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationComponent')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
            </Grid>
            <Grid item lg={12} md={12} xs={12} classes={{ root: ((values.evaluationComponent?.every((v) => !v.selected) && !firstCheck) || (values.total >= 0 && values.total !== 100 && !firstCheck)) ? classes.evaluationBoxRequired : classes.evaluationBox }}>
                <Grid container lg md xs={12} direction="row">
                    <Grid item>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationRatio')}</Typography>
                    </Grid>
                    <Grid item ml="21px">
                        {(values.evaluationComponent.every((v) => !v.selected) && !firstCheck) &&
                            <Typography classes={{ root: classes.textError }} lineHeight="24px" display="flex">{t('admin.inputForm.msgError.pleaseSelect1')}</Typography>
                        }
                        {((values.total >= 0 && values.total !== 100 && !firstCheck)) &&
                            <Typography classes={{ root: classes.textError }} lineHeight="24px" display="flex">{t('admin.inputForm.msgError.ratio100')}</Typography>
                        }
                    </Grid>
                </Grid>
                <Table classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHead }}>
                        <TableRow>
                            <TableCell rowSpan={2} width={'100px'}>{t('admin.inputForm.table.header.select')}</TableCell>
                            <TableCell rowSpan={2} width={'150px'}>{t('admin.inputForm.table.header.component')}</TableCell>
                            <TableCell rowSpan={2} width={'150px'}>{t('admin.inputForm.table.header.ratio')}</TableCell>
                            <TableCell rowSpan={2} width={'500px'}></TableCell>
                            <TableCell rowSpan={2} width={'80px'}></TableCell>
                            <TableCell rowSpan={2} align="center" width={'150px'}>
                                <Grid item>{t('admin.inputForm.table.header.evaluate')}</Grid>
                                <Grid item>{t('admin.inputForm.table.header.displayOnly')}</Grid>
                            </TableCell>
                            <TableCell colSpan={2} align='center'>{t('admin.inputForm.table.header.comment')}</TableCell>
                        </TableRow>
                        <TableRow>
                            <TableCell align='center'>{t('admin.inputForm.table.header.employee')}</TableCell>
                            <TableCell align='center'>{t('admin.inputForm.table.header.evaluator')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {values.evaluationComponent.map((row, idx) => (
                            <>
                                {row?.lists?.map((list, idx2) => (
                                    <TableRow
                                        key={row.componentName + idx2}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        classes={idx2 === row?.lists.length ? { root: classes.tableBody } : { root: classes.tableBodyWithoutBorder }}
                                    >
                                        {idx2 === 0
                                            ?
                                            <TableCell component="th" scope="row">
                                                <Checkbox
                                                    classes={launchForm ? { root: classes.selectDisabled } : launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                    value={row.selected}
                                                    checked={row.selected}
                                                    disabled={launchForm}
                                                    onChange={e => formikChangeCheckbox(e, `${pathData + 'evaluationComponent[' + idx + '].selected'}`, `${pathData + 'evaluationComponent[' + idx + '].lists[' + idx2 + '].ratio'}`, pathData + 'evaluation', null, `${pathData + 'evaluationComponent[' + idx + '].lists'}`, row)} />
                                            </TableCell>
                                            :
                                            <TableCell>
                                            </TableCell>
                                        }
                                        {idx2 === 0
                                            ?
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {row.componentName === 'custom' ? 'Custom Form' : row.componentName === 'probation' ? 'Custom Form (Probation)' : Util.upperFirstWord(row.componentName)}
                                                </Typography>
                                            </TableCell>
                                            :
                                            <TableCell>
                                            </TableCell>
                                        }
                                        <TableCell>
                                            <TextField
                                                classes={{ root: (!row.selected) || launchForm ? classes.inputTopicDisabled : classes.input }}
                                                fullWidth
                                                error={Boolean((!values.evaluationComponent[idx]?.lists[idx2]?.ratio && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.ratio === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck}
                                                helperText={(((!values.evaluationComponent[idx]?.lists[idx2]?.ratio && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.ratio === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck) && t('admin.inputForm.msgError.pleaseFill')}
                                                margin="normal"
                                                name="ratio"
                                                disabled={(!row.selected) || launchForm}
                                                onBlur={formik.handleBlur}
                                                onChange={e => formikChangeOnlyNumber(e, `${pathData + 'evaluationComponent[' + idx + '].lists[' + idx2 + '].ratio'}`, `${pathData}evaluation`, index)}
                                                type="text"
                                                value={list.ratio}
                                                variant="outlined"
                                                InputLabelProps={{
                                                    shrink: true,
                                                }}
                                                sx={list.ratio == 0 ? {
                                                    'input': {
                                                        height: '8px',
                                                        position: "relative",
                                                        color: '#AAAAAA',
                                                    },
                                                    '& ::placeholder': {
                                                        fontWeight: '300',
                                                        color: '#AAAAAA',
                                                        fontSize: '16px'
                                                    }
                                                } : {}}
                                                placeholder={t('admin.inputForm.placeholder.ratio')}
                                            />
                                        </TableCell>
                                        {row.componentName === 'probation'
                                            &&
                                            <TableCell>
                                                <Select
                                                    id="workload-select-customForm"
                                                    inputlabelprops={{ shrink: false }}
                                                    variant="outlined"
                                                    size="small"
                                                    value={values?.evaluationComponent[idx]?.lists[idx2]?.custom_form}
                                                    onChange={e => formikChange(e, `${pathData}evaluationComponent[${idx}].lists[${idx2}].custom_form`)}
                                                    defaultValue=""
                                                    displayEmpty
                                                    disabled={(!row.selected) || launchForm}
                                                    placeholder={t('admin.inputForm.placeholder.probation')}
                                                    error={Boolean((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck}
                                                    helperText={(((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck) && t('admin.inputForm.msgError.pleaseSelect')}
                                                    fullWidth
                                                    name="customForm"
                                                    classes={(!row.selected) || launchForm ? { select: classes.selectDisabled } : { root: classes.input }}
                                                    sx={{ marginBottom: 0, marginTop: '9px' }}
                                                >
                                                    <MenuItem disabled value="">
                                                        <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.probation')}</Typography>
                                                    </MenuItem>
                                                    {
                                                        probationList?.length > 0 ?
                                                            probationList.map(item => {
                                                                return (
                                                                    <MenuItem value={item.serial} key={item.serial}>
                                                                        {item.name}
                                                                    </MenuItem>
                                                                )
                                                            })
                                                            : <MenuItem value="">
                                                                ---{t('label.notFund')}---
                                                            </MenuItem>
                                                    }
                                                </Select>
                                                {((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                            </TableCell>
                                        }
                                        {row.componentName === 'custom'
                                            ?
                                            <>
                                                <TableCell>
                                                    <Select
                                                        id="workload-select-customForm"
                                                        inputlabelprops={{ shrink: false }}
                                                        variant="outlined"
                                                        size="small"
                                                        value={values?.evaluationComponent[idx]?.lists[idx2]?.custom_form}
                                                        onChange={e => formikChange(e, `${pathData}evaluationComponent[${idx}].lists[${idx2}].custom_form`)}
                                                        defaultValue=""
                                                        displayEmpty
                                                        disabled={(!row.selected) || launchForm}
                                                        placeholder={t('admin.inputForm.placeholder.custom_form')}
                                                        error={Boolean((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck}
                                                        helperText={(((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck) && t('admin.inputForm.msgError.pleaseSelect')}
                                                        fullWidth
                                                        name="customForm"
                                                        classes={(!row.selected) || launchForm ? { select: classes.selectDisabled } : { root: classes.input }}
                                                        sx={{ marginBottom: 0, marginTop: '9px' }}
                                                    >
                                                        <MenuItem disabled value="">
                                                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.customForm')}</Typography>
                                                        </MenuItem>
                                                        {
                                                            customFormList?.length > 0 ?
                                                                customFormList.map(item => {
                                                                    return (
                                                                        <MenuItem value={item.serial} key={item.serial}>
                                                                            {item.name}
                                                                        </MenuItem>
                                                                    )
                                                                })

                                                                : <MenuItem value="">
                                                                    ---{t('label.notFund')}---
                                                                </MenuItem>
                                                        }
                                                    </Select>
                                                    {((!values.evaluationComponent[idx]?.lists[idx2]?.custom_form && values.evaluationComponent[idx]?.selected) || (values.evaluationComponent[idx]?.lists[idx2]?.custom_form === '' && values.evaluationComponent[idx]?.selected)) && !firstCheck ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                                </TableCell>
                                                <TableCell align='center'>
                                                    {idx2 === 0
                                                        ?
                                                        <Typography onClick={() => row.selected ? addCustomForm(values.evaluationComponent, idx, idx2, pathData) : null} style={row.selected ? styles.btnLink : styles.disBtnLink}>
                                                            + Add
                                                        </Typography>
                                                        :
                                                        <DeleteIcon className={classes.fillRed} style={{ marginTop: '10px' }} onClick={() => row.selected ? removeCustomForm(values.evaluationComponent, idx, idx2, pathData) : null} />
                                                    }
                                                </TableCell>
                                                <TableCell align='center'>
                                                    {row.selected
                                                        ?
                                                        <Checkbox
                                                            classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                            value={list.allow_evaluate}
                                                            checked={list.allow_evaluate}
                                                            disabled={launchForm}
                                                            onChange={e => formikChangeCheckbox(e, `${pathData + 'evaluationComponent[' + idx + '].lists[' + idx2 + '].allow_evaluate'}`)}
                                                        />
                                                        :
                                                        <Box className={classes.disabledBox}>
                                                        </Box>
                                                    }
                                                </TableCell>
                                            </>
                                            :

                                            <>
                                                <TableCell></TableCell>
                                                <TableCell></TableCell>
                                                {row.componentName !== 'probation' &&
                                                    <TableCell></TableCell>
                                                }
                                            </>
                                        }
                                        <TableCell align='center'>
                                            {row.selected
                                                ?
                                                <Checkbox
                                                    classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                    value={list.required.employee}
                                                    checked={list.required.employee}
                                                    disabled={launchForm}
                                                    onChange={e => formikChangeCheckbox(e, `${pathData + 'evaluationComponent[' + idx + '].lists[' + idx2 + '].required.employee'}`)}
                                                />
                                                :
                                                <Box className={classes.disabledBox}>
                                                </Box>
                                            }
                                        </TableCell>
                                        <TableCell align='center'>
                                            {row.selected
                                                ?
                                                <Checkbox
                                                    disabled={(!row.selected) || launchForm}
                                                    classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                    value={list.required.evaluator}
                                                    checked={list.required.evaluator}
                                                    onChange={e => formikChangeCheckbox(e, `${pathData + 'evaluationComponent[' + idx + '].lists[' + idx2 + '].required.evaluator'}`)}
                                                />
                                                :
                                                <Box className={classes.disabledBox}>
                                                </Box>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                            </>
                        )
                        )}
                        <TableRow>
                            <TableCell sx={{ borderBottom: 0 }}></TableCell>
                            <TableCell sx={{ borderBottom: 0 }}></TableCell>
                            <TableCell sx={{ borderBottom: 0 }} align='center'>
                                <Grid container direction="row" justifyContent={'space-between'}>
                                    <Grid item>
                                        <Typography align='left' classes={{ root: classes.checkboxLabel }}>
                                            {t('admin.inputForm.total')}:
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography align='right' fontSize={'18px'} fontWeight="500"
                                            sx={{ color: generateColor(values.total) }}
                                        >
                                            {values.total}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const showGoalTable = (errors, touched, dataShow = [], pathData, type, values, firstCheck) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{pathData.indexOf('goal') > -1 ? t('admin.inputForm.goalCategory') : t('admin.inputForm.competency')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
            </Grid>
            <Grid item lg={12} md={12} xs={12} classes={{ root: ((dataShow.every((v) => !v.selected) && !firstCheck) || (values.total >= 0 && values.total !== 100 && !firstCheck)) ? classes.evaluationBoxRequired : classes.evaluationBox }}>
                <Grid container lg md xs={12} direction="row">
                    <Grid item>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{pathData.indexOf('goal') > -1 ? t('admin.inputForm.manageGoal') : t('admin.inputForm.manageCompetency')}</Typography>
                    </Grid>
                    <Grid item ml="21px">
                        {(dataShow.every((v) => !v.selected) && !firstCheck) &&
                            <Typography classes={{ root: classes.textError }} lineHeight="24px" display="flex">{t('admin.inputForm.msgError.pleaseSelect1')}</Typography>
                        }
                        {((values.total >= 0 && values.total !== 100 && !firstCheck)) &&
                            <Typography classes={{ root: classes.textError }} lineHeight="24px" display="flex">{t('admin.inputForm.msgError.ratio100')}</Typography>
                        }
                    </Grid>
                </Grid>
                <Table classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'100px'}>{t('admin.inputForm.table.header.select')}</TableCell>
                            <TableCell width={'200px'}>{t('admin.inputForm.table.header.goalCategory')}</TableCell>
                            <TableCell>{t('admin.inputForm.table.header.ratio')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataShow?.map((row, idx) => (
                            <TableRow
                                key={row.componentName}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                classes={{ root: classes.tableBody }}
                            >
                                <TableCell component="th" scope="row">
                                    <Checkbox
                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                        value={row.selected}
                                        checked={row.selected}
                                        disabled={launchForm}
                                        onChange={e => formikChangeCheckbox(e, `${pathData + '[' + idx + '].selected'}`, `${pathData + '[' + idx + '].ratio'}`, type)} />
                                </TableCell>
                                <TableCell>
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {Util.capitalizedString(row.name)}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        classes={{ root: (!row.selected) || launchForm ? classes.disabled : classes.input }}
                                        fullWidth
                                        error={Boolean((row.ratio === '' || row.ratio === '') && (row.selected && !firstCheck))}
                                        helperText={((row.ratio === '' || row.ratio === '') && (row.selected && !firstCheck)) && t('admin.inputForm.msgError.pleaseSelect')}
                                        margin="normal"
                                        name="ratio"
                                        disabled={(!row.selected) || launchForm}
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChangeOnlyNumber(e, `${pathData + '[' + idx + '].ratio'}`, type)}
                                        type="text"
                                        value={row.ratio}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.ratio')}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                        <TableRow>
                            <TableCell sx={{ borderBottom: 0 }}></TableCell>
                            <TableCell sx={{ borderBottom: 0 }}></TableCell>
                            <TableCell sx={{ borderBottom: 0 }} align='center'>
                                <Grid container direction="row" justifyContent={'space-between'}>
                                    <Grid item>
                                        <Typography align='left' classes={{ root: classes.checkboxLabel }}>
                                            {t('admin.inputForm.total')}:
                                        </Typography>
                                    </Grid>
                                    <Grid item>
                                        <Typography align='right' fontSize={'18px'} fontWeight="500"
                                            sx={{ color: generateColor(values.total) }}
                                        >
                                            {values.total}
                                        </Typography>
                                    </Grid>
                                </Grid>
                            </TableCell>
                        </TableRow>
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const showDisplayGoalTable = (dataShow) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg={6} md={6} xs={6} classes={{ root: classes.evaluationBox }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex" style={{ fontWeight: '500 !important' }}>{t('admin.inputForm.displayGoal')}</Typography>
                <Table classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'100px'}>{t('admin.inputForm.table.header.default')}</TableCell>
                            <TableCell width={'350px'}>{t('admin.inputForm.table.header.iconEn')}</TableCell>
                            <TableCell width={'350px'}>{t('admin.inputForm.table.header.iconTh')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataShow?.map((row, idx) => (
                            <TableRow
                                key={row.componentName}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                classes={{ root: classes.tableBodyGoal }}
                            >
                                <TableCell component="th" scope="row">
                                    {row.selected &&
                                        <Radio
                                            checked={row.selected}
                                            value={row.selected}
                                            name="radio-buttons"
                                            inputProps={{ 'aria-label': 'A' }}
                                            disabled={launchForm}
                                        />
                                    }
                                </TableCell>
                                <TableCell>
                                    <Box
                                        sx={{
                                            width: '120px', height: '40px',
                                            backgroundColor: row.color.background,
                                            border: row.color.background === '#FFFFFF' ? `1px solid ${row.color.font}` : null,
                                            borderRadius: '5px', paddingTop: '8px'
                                        }}>
                                        <Typography classes={{ root: classes.checkboxLabel }} sx={{ textAlign: 'center', color: row.color.font, fontSize: '16px', fontWeight: 500 }}>
                                            {row.nameEn}
                                        </Typography>
                                    </Box>
                                </TableCell>
                                <TableCell>
                                    <Box
                                        sx={{
                                            width: '120px', height: '40px',
                                            backgroundColor: row.color.background,
                                            border: row.color.background === '#FFFFFF' ? `1px solid ${row.color.font}` : null,
                                            borderRadius: '5px', paddingTop: '8px'
                                        }}>
                                        <Typography classes={{ root: classes.checkboxLabel }} sx={{ textAlign: 'center', color: row.color.font, fontSize: '16px', fontWeight: 500 }}>
                                            {row.nameTh}
                                        </Typography>
                                    </Box>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const showRatingScale = (errors, touched, dataShow = [], pathData) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
            <Grid item lg={12} md={12} xs={12} classes={{ root: classes.evaluationBox }}>
                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.label.manageRatingScale')}</Typography>
                <Table classes={{ root: classes.table }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'100px'}>{t('admin.inputForm.table.header.scaleLevel')}</TableCell>
                            <TableCell width={'200px'}>{t('admin.inputForm.table.header.value')}</TableCell>
                            <TableCell width={'400px'}>{t('admin.inputForm.table.header.descriptionScaleEn')}</TableCell>
                            <TableCell width={'50px'}></TableCell>
                            <TableCell width={'400px'}>{t('admin.inputForm.table.header.descriptionScaleTh')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataShow?.map((row, idx) => (
                            <TableRow
                                key={row.componentName}
                                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                classes={{ root: classes.tableBody }}
                            >
                                <TableCell component="th" scope="row">
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {row.scaleLevel ?? row.level}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <Typography classes={{ root: classes.checkboxLabel }}>
                                        {row.value}
                                    </Typography>
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        rows={2}
                                        multiline
                                        classes={{ root: classes.input }}
                                        // error={Boolean(touched.descriptionEn && errors.descriptionEn)}
                                        fullWidth
                                        disabled
                                        // helperText={touched.descriptionEn && errors.descriptionEn}
                                        margin="normal"
                                        name="descriptionEn"
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `${pathData + '[' + idx + '].descriptionEn'}`)}
                                        type="text"
                                        value={row.descriptionEn}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        diabled={launchForm}
                                    />
                                </TableCell>
                                <TableCell>
                                </TableCell>
                                <TableCell>
                                    <TextField
                                        rows={2}
                                        multiline
                                        classes={{ root: classes.input }}
                                        // error={Boolean(touched.descriptionTh && errors.descriptionTh)}
                                        fullWidth
                                        disabled
                                        // helperText={touched.descriptionTh && errors.descriptionTh}
                                        margin="normal"
                                        name="descriptionTh"
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `${pathData + '[' + idx + '].descriptionTh'}`)}
                                        type="text"
                                        value={row.descriptionTh}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const showSummary = (dataShow) => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'30px'}>
            <Grid item lg={12} md={12} xs={12} classes={{ root: classes.summaryTable }}>
                <Table classes={{ root: classes.tableSummary }}>
                    <TableHead classes={{ root: classes.tableHeadBigger }}>
                        <TableRow>
                            <TableCell width={'600px'}>{t('admin.inputForm.table.header.templateName')}</TableCell>
                            <TableCell width={'250px'}>{t('admin.inputForm.table.header.startDate')}</TableCell>
                            <TableCell width={'250px'}>{t('admin.inputForm.table.header.endDate')}</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {dataShow?.map((row, idx) => (
                            <>
                                <TableRow
                                    key={row.name}
                                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    classes={{ root: classes.tableBody }}
                                >
                                    <TableCell onClick={() => expanded(!row.isOpen, `summary[${idx}].isOpen`)} sx={{ cursor: 'pointer' }}>
                                        <Grid container lg md xs direction="row">
                                            <Grid item>
                                                {row.isOpen
                                                    ?
                                                    <Box sx={{ backgrounColor: '#F5F5F5', width: '25px', height: '25px', marginRight: '16px' }}>
                                                        <Icon style={{ color: '#6B6B6B', fontSize: 25, background: 'rgba(245,245,245)' }}>{'keyboard_arrow_up'}</Icon>
                                                    </Box>
                                                    :
                                                    <Box sx={{ backgrounColor: '#F5F5F5', width: '25px', height: '25px', marginRight: '16px' }}>
                                                        <Icon style={{ color: '#6B6B6B', fontSize: 25, background: 'rgba(245,245,245)' }}>{'keyboard_arrow_down'}</Icon>
                                                    </Box>
                                                }
                                            </Grid>
                                            <Grid item>
                                                <Typography classes={{ root: classes.checkboxLabelHighlight }}>
                                                    {row.name}
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                    </TableCell>
                                    <TableCell>
                                        <Typography classes={{ root: classes.checkboxLabelHighlight }}>
                                            {row.startDate}
                                        </Typography>
                                    </TableCell>
                                    <TableCell>
                                        <Typography classes={{ root: classes.checkboxLabelHighlight }}>
                                            {row.endDate}
                                        </Typography>
                                    </TableCell>
                                </TableRow>
                                {row.isOpen &&
                                    row.children.map((item) => {
                                        return <TableRow
                                            key={item.name}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                            classes={{ root: classes.tableBody }}
                                        >
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }} sx={{ paddingLeft: '42px' }}>
                                                    {item.name}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {item.startDate}
                                                </Typography>
                                            </TableCell>
                                            <TableCell>
                                                <Typography classes={{ root: classes.checkboxLabel }}>
                                                    {item.endDate}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    })
                                }
                            </>
                        ))}
                    </TableBody>
                </Table>
            </Grid>
        </Grid>
    }

    const generateColor = (val) => {
        if (parseFloat(val) === 0) {
            return '#A3A3A3'
        } else if (parseFloat(val) === 100 || parseFloat(val) === 100.00) {
            return '#5DA196'
        } else {
            return '#CC6058'
        }
    }

    const templateForm = () => {
        return <Paper id="template-form" elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {t('admin.inputForm.templateCode')}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.code')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <TextField
                        error={Boolean(formik.touched.code && formik.errors.code) || Boolean(codeExist)}
                        fullWidth
                        helperText={(formik.touched.code && formik.errors.code) || (codeExist && 'This code is already used.')}
                        margin="normal"
                        name="code"
                        disabled={type === 'edit'}
                        onChange={e => formikChange(e, "code")}
                        type="text"
                        value={formik.values.code}
                        maxLength={20}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.evalutationJourneyCode')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg={0.5} md={0.5} xs={0.5}></Grid>
                <Grid item lg md xs={5} sx={{ paddingTop: "0 !important" }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.cycle')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select-main"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.cycle}
                        onChange={e => formikChange(e, "cycle")}
                        defaultValue=""
                        displayEmpty
                        disabled={type === 'edit' || type === 'duplicate'}
                        placeholder={t('admin.inputForm.placeholder.evalutationJourneyCycle')}
                        error={Boolean(formik.touched.cycle && formik.errors.cycle)}
                        fullWidth
                        helperText={formik.touched.cycle && formik.errors.cycle}
                        name="cycle"
                        classes={{ root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px !important' }}
                        renderValue={(selected) => {
                            if (selected == null || selected === "") {
                                return <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>
                                    {t('admin.inputForm.placeholder.evalutationJourneyCycle')}
                                </Typography>;
                            } else {
                                return cycleList.filter((item) => item.serial === selected)[0]?.name
                            }
                        }}
                    >
                        {
                            cycleList?.length > 0 ?
                                cycleList.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.cycle && formik.errors.cycle ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.cycle} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const prForm = () => {
        return <>
            {formik.values.prTemplateList.map((_, idx) => {
                return <Paper id={`expanded-${idx}`} elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px", marginBottom: '33px' }} classes={{ root: classes.error }}>
                    <Grid container lg md xs={12} direction="row" justifyContent={'space-between'} onClick={() => expandedPr(true, `prTemplateList[${idx}].isOpen`, idx)} sx={{ cursor: 'pointer' }}>
                        <Grid item lg md xs={12}>
                            <Typography classes={{ root: classes.titleName }}>
                                {steps[activeStep]} {idx + 1}
                            </Typography>
                        </Grid>
                        <Grid item lg md xs={12} sx={{ marginRight: '40px' }}>
                            {formik.values.prTemplateList[idx]?.isOpen
                                ?
                                <Box sx={{ float: 'right', width: '31.5px', height: '31.5px', border: '1px solid #DADADA' }}>
                                    <Icon style={{ color: '#6B6B6B', fontSize: '30px' }}>{'keyboard_arrow_up'}</Icon>
                                </Box>
                                :
                                <Box sx={{ float: 'right', width: '31.5px', height: '31.5px', border: '1px solid #DADADA' }}>
                                    <Icon style={{ color: '#6B6B6B', fontSize: '30px' }}>{'keyboard_arrow_down'}</Icon>
                                </Box>
                            }
                        </Grid>
                    </Grid>
                    {formik.values.prTemplateList[idx]?.isOpen &&
                        <>
                            <Grid container lg md xs={12} direction="column">
                                <Grid item lg md xs={12}>
                                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                                </Grid>
                            </Grid>
                            {codeAndCycleForm()}
                            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.prTemplateList[idx]?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.prTemplateList[idx]?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.prTemplateList[idx]?.nameEn, "").length}/100</Typography>
                                    </Box>
                                    <TextField
                                        error={Boolean(formik.values.prTemplateList[idx].nameEn === '' && !firstPrTemplate) || Util.formatData(formik?.values?.prTemplateList[idx]?.nameEn, "").length > 100}
                                        fullWidth
                                        helperText={(formik.values.prTemplateList[idx].nameEn === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseFill')}
                                        margin="normal"
                                        name="nameEn"
                                        disabled={serial !== undefined ? true : false}
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].nameEn`)}
                                        type="text"
                                        value={formik.values.prTemplateList[idx]?.nameEn}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.prTemplateList[idx]?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.prTemplateList[idx]?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.prTemplateList[idx]?.nameTh, "").length}/100</Typography>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="nameTh"
                                        disabled={serial !== undefined ? true : false}
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].nameTh`)}
                                        error={Boolean(formik.values.prTemplateList[idx].nameTh === '' && !firstPrTemplate) || Util.formatData(formik?.values?.prTemplateList[idx]?.nameTh, "").length > 100}
                                        helperText={(formik.values.prTemplateList[idx].nameTh === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseFill')}
                                        type="text"
                                        value={formik.values.prTemplateList[idx].nameTh}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionEn')} </Typography>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="descriptionEn"
                                        disabled={serial !== undefined ? true : false}
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].descriptionEn`)}
                                        type="text"
                                        value={formik.values.prTemplateList[idx].descriptionEn}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionTh')}</Typography>
                                    <TextField
                                        fullWidth
                                        margin="normal"
                                        name="descriptionTh"
                                        disabled={serial !== undefined ? true : false}
                                        onBlur={formik.handleBlur}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].descriptionTh`)}
                                        type="text"
                                        value={formik.values.prTemplateList[idx].descriptionTh}
                                        variant="outlined"
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                                        classes={{ root: classes.input }}
                                    />
                                </Grid>
                            </Grid>
                            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationType')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <Select
                                        id="workload-select"
                                        inputlabelprops={{ shrink: false }}
                                        variant="outlined"
                                        size="small"
                                        value={formik.values.prTemplateList[idx].evaluationType}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].evaluationType`)}
                                        defaultValue=""
                                        displayEmpty
                                        placeholder={t('admin.inputForm.placeholder.evaluationType')}
                                        error={Boolean(formik.values.prTemplateList[idx].evaluationType === '' && !firstPrTemplate)}
                                        fullWidth
                                        helperText={(formik.values.prTemplateList[idx].evaluationType === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect')}
                                        name="evaluationType"
                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                                        sx={{ marginBottom: 0, marginTop: '16px' }}
                                        disabled={launchForm}
                                    >
                                        <MenuItem disabled value="">
                                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.evaluationType')}</Typography>
                                        </MenuItem>
                                        {
                                            evaluationType?.length > 0 ?
                                                evaluationType.map(item => {
                                                    return (
                                                        <MenuItem value={item.serial} key={item.serial}>
                                                            {item.description}
                                                        </MenuItem>
                                                    )
                                                })

                                                : <MenuItem value="">
                                                    ---{t('label.notFund')}---
                                                </MenuItem>
                                        }
                                    </Select>
                                    {(formik.values.prTemplateList[idx].evaluationType === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect') ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                </Grid>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.scoreDecimal')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <Select
                                        id="workload-select"
                                        inputlabelprops={{ shrink: false }}
                                        variant="outlined"
                                        size="small"
                                        value={formik.values.prTemplateList[idx].scoreDecimal}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].scoreDecimal`)}
                                        defaultValue=""
                                        displayEmpty
                                        placeholder={t('admin.inputForm.placeholder.scoreDecimal')}
                                        error={Boolean(formik.values.prTemplateList[idx].scoreDecimal === '' && !firstPrTemplate)}
                                        fullWidth
                                        helperText={(formik.values.prTemplateList[idx].scoreDecimal === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect')}
                                        name="scoreDecimal"
                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                                        sx={{ marginBottom: 0, marginTop: '16px' }}
                                        disabled={launchForm}
                                    >
                                        <MenuItem disabled value="">
                                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.scoreDecimal')}</Typography>
                                        </MenuItem>
                                        {
                                            scoreDecimal?.length > 0 ?
                                                scoreDecimal.map(item => {
                                                    return (
                                                        <MenuItem value={item.serial} key={item.serial}>
                                                            {item.code}
                                                        </MenuItem>
                                                    )
                                                })

                                                : <MenuItem value="">
                                                    ---{t('label.notFund')}---
                                                </MenuItem>
                                        }
                                    </Select>
                                    {(formik.values.prTemplateList[idx].scoreDecimal === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect') ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                </Grid>
                            </Grid>
                            <Grid container lg={6} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.workflow')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                    <Select
                                        id="workload-select"
                                        inputlabelprops={{ shrink: false }}
                                        variant="outlined"
                                        size="small"
                                        value={formik.values.prTemplateList[idx].workflow}
                                        onChange={e => formikChange(e, `prTemplateList[${idx}].workflow`, `prTemplateList[${idx}]`)}
                                        defaultValue=""
                                        displayEmpty
                                        placeholder={t('admin.inputForm.placeholder.workflow')}
                                        error={Boolean(formik.values.prTemplateList[idx].workflow === '' && !firstPrTemplate)}
                                        fullWidth
                                        helperText={(formik.values.prTemplateList[idx].workflow === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect')}
                                        name="workflow"
                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                                        sx={{ marginBottom: 0, marginTop: '16px' }}
                                        disabled={launchForm}
                                    >
                                        <MenuItem disabled value="">
                                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.workflow')}</Typography>
                                        </MenuItem>
                                        {
                                            workflowList?.length > 0 ?
                                                workflowList.map(item => {
                                                    return (
                                                        <MenuItem value={item.serial} key={item.serial}>
                                                            {item.description}
                                                        </MenuItem>
                                                    )
                                                })

                                                : <MenuItem value="">
                                                    ---{t('label.notFund')}---
                                                </MenuItem>
                                        }
                                    </Select>
                                    {(formik.values.prTemplateList[idx].workflow === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseSelect') ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                </Grid>
                            </Grid>
                            {formik.values.prTemplateList[idx].workflow &&
                                showWorkflowTable(formik.values.prTemplateList[idx], formik.errors, formik.touched.prTemplateList[idx], `prTemplateList[${idx}]`, true, true, true, true, firstPrTemplate, false)
                            }
                            {/* {showEvaluationTable(formik.values.prTemplateList[idx], formik.errors, formik.touched.prTemplateList[idx], `prTemplateList[${idx}]`, idx, firstPrTemplate)} */}
                            {((formik.values.promotion || formik.values.idp) && !formik.values.prTemplateList[idx].workflow) &&
                                <Grid container lg={6} md={6} xs={6} display="inline-flex">
                                </Grid>
                            }
                            <Grid container direction="row">
                                <Grid item>
                                    <Checkbox
                                        classes={{ root: classes.selectDisabled }}
                                        value={formik.values.is_enforce_start}
                                        checked={formik.values.is_enforce_start}
                                        disabled />

                                </Grid>
                                <Grid item sx={{ alignSelf: 'center' }}>
                                    <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.enforce')}</Typography>
                                </Grid>
                            </Grid>
                            <Box ml={'43px'}>
                                <Typography classes={{ root: classes.textShowLittle }} lineHeight="24px" display="flex">{t('admin.inputForm.enforceDesc')}</Typography>
                            </Box>
                            {/* {(formik.values.promotion || formik.values.idp) &&
                                <Grid container lg={6} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                                    <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.otherComponent')}</Typography>
                                        {formik.values.idp &&
                                            <Grid container direction="row">
                                                <Grid item>
                                                    <Checkbox
                                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                        value={formik.values.prTemplateList[idx].idp}
                                                        checked={formik.values.prTemplateList[idx].idp}
                                                        onChange={e => formikChangeCheckbox(e, `prTemplateList[${idx}].idp`)}
                                                    />
                                                </Grid>
                                                <Grid item sx={{ alignSelf: 'center' }}>
                                                    <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.idp')}</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                        {formik.values.prTemplateList[idx].idp &&
                                            <Box ml={'43px'}>
                                                <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.idpTemplate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                                                <Select
                                                    id="workload-select"
                                                    inputlabelprops={{ shrink: false }}
                                                    variant="outlined"
                                                    size="small"
                                                    aria-disabled
                                                    value={formik.values.prTemplateList[idx].idpTemplate}
                                                    onChange={e => formikChange(e, `prTemplateList[${idx}].idpTemplate`)}
                                                    defaultValue=""
                                                    displayEmpty
                                                    placeholder={t('admin.inputForm.placeholder.idpTemplate')}
                                                    error={Boolean(formik.touched.prTemplateList[idx].idpTemplate === '' || formik.values.prTemplateList[idx].idpTemplate === '') && !firstPrTemplate}
                                                    fullWidth
                                                    helperText={(formik.touched.prTemplateList[idx].idpTemplate === '' || formik.values.prTemplateList[idx].idpTemplate === '' && !firstPrTemplate) && t('admin.inputForm.msgError.pleaseFill')}
                                                    name="idpTemplate"
                                                    classes={{ root: classes.input }}
                                                    sx={{ marginBottom: 0, marginTop: '16px' }}
                                                >
                                                    <MenuItem disabled value="">
                                                        <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.idpTemplate')}</Typography>
                                                    </MenuItem>
                                                    {
                                                        idpTemplate?.length > 0 ?
                                                            idpTemplate.map(item => {
                                                                return (
                                                                    <MenuItem value={item.serial} key={item.serial}>
                                                                        {item.value}
                                                                    </MenuItem>
                                                                )
                                                            })

                                                            : <MenuItem value="">
                                                                ---{t('label.notFund')}---
                                                            </MenuItem>
                                                    }
                                                </Select>
                                                {Boolean(formik.touched.prTemplateList[idx].idpTemplate === '' || formik.values.prTemplateList[idx].idpTemplate === '') && !firstPrTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{t('admin.inputForm.msgError.pleaseSelect')} </FormHelperText>) : <></>}
                                            </Box>
                                        }
                                        {formik.values.promotion &&
                                            <Grid container direction="row">
                                                <Grid item>
                                                    <Checkbox
                                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                                        value={formik.values.prTemplateList[idx].promotion}
                                                        checked={formik.values.prTemplateList[idx].promotion}
                                                        onChange={e => formikChangeCheckbox(e, `prTemplateList[${idx}].promotion`)}
                                                    />
                                                </Grid>
                                                <Grid item sx={{ alignSelf: 'center' }}>
                                                    <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.promotion')}</Typography>
                                                </Grid>
                                            </Grid>
                                        }
                                        {formik.values.promotion &&
                                            <Box ml={'34px'}>
                                                <Typography classes={{ root: classes.textShowLittle }} lineHeight="24px" display="flex">{t('admin.inputForm.promotionDesc')}</Typography>
                                            </Box>
                                        }
                                    </Grid>
                                </Grid>
                            } */}
                        </>
                    }
                </Paper>
            })
            }
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </>
    }

    const probationForm = () => {
        return <Paper id="evaluation-form" elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ paddingTop: "14px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                        <FormGroup >
                            <FormControlLabel
                                sx={{ m: 0, color: '#404349', fontWeight: '400', fontSize: '16px' }}
                                control={<IOSSwitch checked={formik.values.probation?.statusActive} disabled={type === 'edit' ? isUsed : false} onChange={e => formikChangeCheckbox(e, 'probation.statusActive')} />}
                                label={formik.values.probation?.statusActive ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                            />
                        </FormGroup>
                    </Box>
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.nameEn && formik.errors.probation?.nameEn && !firstEvaTemplate) || Util.formatData(formik?.values?.probation?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.probation?.nameEn && !firstEvaTemplate) && formik.errors.probation?.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.nameEn")}
                        type="text"
                        value={formik.values.probation.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.nameTh && formik.errors.probation?.nameTh && !firstEvaTemplate) || Util.formatData(formik?.values?.probation?.nameTh, "").length > 100}
                        helperText={(formik.touched.probation?.nameTh && !firstEvaTemplate) && formik.errors.probation?.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.nameTh")}
                        type="text"
                        value={formik.values.probation.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionEn')} </Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.descriptionEn")}
                        type="text"
                        value={formik.values.probation.descriptionEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionTh')}</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.descriptionTh")}
                        type="text"
                        value={formik.values.probation.descriptionTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationType')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <TextField
                        classes={{ root: classes.input }}
                        fullWidth
                        margin="normal"
                        name="expected"
                        disabled
                        type="text"
                        value={"Probation"}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.evaluationType')}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.scoreDecimal')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.scoreDecimal}
                        onChange={e => formikChange(e, "probation.scoreDecimal")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.scoreDecimal')}
                        error={Boolean(formik.touched.probation?.scoreDecimal && formik.errors.probation?.scoreDecimal && !firstEvaTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.scoreDecimal && formik.errors.probation?.scoreDecimal && !firstEvaTemplate}
                        name="scoreDecimal"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.scoreDecimal')}</Typography>
                        </MenuItem>
                        {
                            scoreDecimal?.length > 0 ?
                                scoreDecimal.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.code}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.scoreDecimal && formik.errors.probation?.scoreDecimal && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.scoreDecimal} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.ratingScale')}</Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.ratingScale}
                        onChange={e => formikChange(e, "probation.ratingScale")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.ratingScale')}
                        error={Boolean(formik.touched.probation?.ratingScale && formik.errors.probation?.ratingScale && !firstGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.ratingScale && formik.errors.probation?.ratingScale && !firstGoalTemplate}
                        name="ratingScale"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.ratingScale')}</Typography>
                        </MenuItem>
                        {
                            ratingScale?.length > 0 ?
                                ratingScale.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.ratingScale && formik.errors.probation?.ratingScale && !firstGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.ratingScale} </FormHelperText>) : <></>}
                </Grid>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.expectRating')}</Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.expectRating}
                        onChange={e => formikChange(e, "probation.expectRating")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.expectRating')}
                        fullWidth
                        name="expectRating"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.expectRating')}</Typography>
                        </MenuItem>
                        {
                            evaExpectRating?.length > 0 ?
                                evaExpectRating.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.value}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                </Grid>
            </Grid>
            <Grid container lg={6} md={6} xs={6} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.workflow')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.workflow}
                        onChange={e => formikChange(e, "probation.workflow")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.workflow')}
                        error={Boolean(formik.touched.probation?.workflow && formik.errors.probation?.workflow && !firstEvaTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.workflow && formik.errors.probation?.workflow && !firstEvaTemplate}
                        name="workflow"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.workflow')}</Typography>
                        </MenuItem>
                        {
                            workflowList?.length > 0 ?
                                workflowList.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.description}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.workflow && formik.errors.probation?.workflow && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.workflow} </FormHelperText>) : <></>}
                </Grid>
            </Grid>

            {formik.values.probation.workflow &&
                showProbrartionTable(formik.values.probation, formik.errors.probation, formik.touched.probation, '', true, true, true, true, firstEvaTemplate)
            }
            {/* <Grid container direction="row">
                <Grid item>
                    <Checkbox
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                        value={formik.values.probation.is_enforce_start}
                        checked={formik.values.probation.is_enforce_start}
                        disabled={launchForm}
                        onChange={e => formikChangeCheckbox(e, 'probation.is_enforce_start')} />
                        
                </Grid>
                <Grid item sx={{ alignSelf: 'center' }}>
                    <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.enforce')}</Typography>
                </Grid>
            </Grid>
            <Box ml={'43px'}>
                <Typography classes={{ root: classes.textShowLittle }} lineHeight="24px" display="flex">{t('admin.inputForm.enforceDesc')}</Typography>
            </Box> */}
            {showEvaluationTable(formik.values.probation, formik.errors.probation, formik.touched.probation, 'probation.', null, firstEvaTemplate)}
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const evaluationForm = () => {
        return <Paper id="evaluation-form" elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.status')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Box sx={{ paddingTop: "14px", height: "100%", "max-height": "55px", display: "flex", "align-items": "center" }}>
                        <FormGroup >
                            <FormControlLabel
                                sx={{ m: 0, color: '#404349', fontWeight: '400', fontSize: '16px' }}
                                control={<IOSSwitch checked={formik.values.statusActive} disabled={(type === 'edit' ? isUsed : false) || launchForm} onChange={e => formikChangeCheckbox(e, 'statusActive')} />}
                                label={formik.values.statusActive ? t('admin.inputForm.active') : t('admin.inputForm.inActive')}
                            />
                        </FormGroup>
                    </Box>
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.nameEn && formik.errors.nameEn && !firstEvaTemplate) || Util.formatData(formik?.values?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.nameEn && !firstEvaTemplate) && formik.errors.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "nameEn")}
                        type="text"
                        value={formik.values.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.nameTh && formik.errors.nameTh && !firstEvaTemplate) || Util.formatData(formik?.values?.nameTh, "").length > 100}
                        helperText={(formik.touched.nameTh && !firstEvaTemplate) && formik.errors.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "nameTh")}
                        type="text"
                        value={formik.values.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionEn')} </Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "descriptionEn")}
                        type="text"
                        value={formik.values.descriptionEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.descriptionTh')}</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "descriptionTh")}
                        type="text"
                        value={formik.values.descriptionTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.evaluationType')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.evaluationType}
                        onChange={e => formikChange(e, "evaluationType")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.evaluationType')}
                        error={Boolean(formik.touched.evaluationType && formik.errors.evaluationType && !firstEvaTemplate)}
                        fullWidth
                        helperText={formik.touched.evaluationType && formik.errors.evaluationType && !firstEvaTemplate}
                        name="evaluationType"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.evaluationType')}</Typography>
                        </MenuItem>
                        {
                            evaluationType?.length > 0 ?
                                evaluationType.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.description}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.evaluationType && formik.errors.evaluationType && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.evaluationType} </FormHelperText>) : <></>}
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.scoreDecimal')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.scoreDecimal}
                        onChange={e => formikChange(e, "scoreDecimal")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.scoreDecimal')}
                        error={Boolean(formik.touched.scoreDecimal && formik.errors.scoreDecimal && !firstEvaTemplate)}
                        fullWidth
                        helperText={formik.touched.scoreDecimal && formik.errors.scoreDecimal && !firstEvaTemplate}
                        name="scoreDecimal"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.scoreDecimal')}</Typography>
                        </MenuItem>
                        {
                            scoreDecimal?.length > 0 ?
                                scoreDecimal.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.code}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.scoreDecimal && formik.errors.scoreDecimal && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.scoreDecimal} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            <Grid container lg={6} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.workflow')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.workflow}
                        onChange={e => formikChange(e, "workflow")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.workflow')}
                        error={Boolean(formik.touched.workflow && formik.errors.workflow && !firstEvaTemplate)}
                        fullWidth
                        helperText={formik.touched.workflow && formik.errors.workflow && !firstEvaTemplate}
                        name="workflow"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.workflow')}</Typography>
                        </MenuItem>
                        {
                            workflowList?.length > 0 ?
                                workflowList.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.description}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.workflow && formik.errors.workflow && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.workflow} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {formik.values.workflow &&
                showWorkflowTable(formik.values, formik.errors, formik.touched, '', true, true, true, true, firstEvaTemplate, false)
            }
            <Grid container direction="row">
                <Grid item>
                    <Checkbox
                        classes={{ root: classes.checkBoxStyle }}
                        value={formik.values.is_enforce_start}
                        checked={formik.values.is_enforce_start}
                        onChange={e => formikChangeCheckbox(e, 'is_enforce_start')} />

                </Grid>
                <Grid item sx={{ alignSelf: 'center' }}>
                    <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.enforce')}</Typography>
                </Grid>
            </Grid>
            <Box ml={'43px'}>
                <Typography classes={{ root: classes.textShowLittle }} lineHeight="24px" display="flex">{t('admin.inputForm.enforceDesc')}</Typography>
            </Box>
            {showEvaluationTable(formik.values, formik.errors, formik.touched, '', null, firstEvaTemplate)}
            <Grid container lg={6} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.otherComponent')}</Typography>
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox
                                classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                checked={formik.values.idp}
                                value={formik.values.idp}
                                disabled={launchForm}
                                onChange={e => formikChangeCheckbox(e, 'idp')} />
                        </Grid>
                        <Grid item sx={{ alignSelf: 'center' }}>
                            <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.idp')}</Typography>
                        </Grid>
                    </Grid>
                    {formik.values.idp &&
                        <Box ml={'43px'}>
                            <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.idpTemplate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                            <Select
                                id="workload-select"
                                inputlabelprops={{ shrink: false }}
                                variant="outlined"
                                size="small"
                                value={formik.values.idpTemplate}
                                onChange={e => formikChange(e, "idpTemplate")}
                                defaultValue=""
                                displayEmpty
                                placeholder={t('admin.inputForm.placeholder.idpTemplate')}
                                error={formik.values.idp ? Boolean(formik.touched.idpTemplate && formik.errors.idpTemplate && !firstEvaTemplate) : null}
                                fullWidth
                                helperText={formik.values.idp ? formik.touched.idpTemplate && formik.errors.idpTemplate && !firstEvaTemplate : null}
                                name="idpTemplate"
                                classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                                sx={{ marginBottom: 0, marginTop: '16px' }}
                                disabled={launchForm}
                            >
                                <MenuItem disabled value="">
                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.idpTemplate')}</Typography>
                                </MenuItem>
                                {
                                    idpTemplate?.length > 0 ?
                                        idpTemplate.map(item => {
                                            return (
                                                <MenuItem value={item.serial} key={item.serial}>
                                                    {item.value}
                                                </MenuItem>
                                            )
                                        })

                                        : <MenuItem value="">
                                            ---{t('label.notFund')}---
                                        </MenuItem>
                                }
                            </Select>
                            {formik.touched.idpTemplate && formik.errors.idpTemplate && !firstEvaTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.idpTemplate} </FormHelperText>) : <></>}
                        </Box>
                    }
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox
                                classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                value={formik.values.promotion}
                                checked={formik.values.promotion}
                                disabled={launchForm}
                                onChange={e => formikChangeCheckbox(e, 'promotion')} />

                        </Grid>
                        <Grid item sx={{ alignSelf: 'center' }}>
                            <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.promotion')}</Typography>
                        </Grid>
                    </Grid>
                    <Box ml={'43px'}>
                        <Typography classes={{ root: classes.textShowLittle }} lineHeight="24px" display="flex">{t('admin.inputForm.promotionDesc')}</Typography>
                    </Box>
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox
                                classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                value={formik.values.pr}
                                checked={formik.values.pr}
                                disabled={launchForm}
                                onChange={e => formikChangeCheckbox(e, 'pr')} />
                        </Grid>
                        <Grid item sx={{ alignSelf: 'center' }}>
                            <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.pr')}</Typography>
                        </Grid>
                    </Grid>
                    {formik.values.pr &&
                        <Box ml={'43px'}>
                            <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.prTemplate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                            <Select
                                id="workload-select"
                                inputlabelprops={{ shrink: false }}
                                variant="outlined"
                                size="small"
                                value={formik.values.prTemplate}
                                onChange={e => formikChangeGenerateForm(e, "prTemplate")}
                                defaultValue=""
                                displayEmpty
                                placeholder={t('admin.inputForm.placeholder.prTemplate')}
                                error={formik.values.pr ? Boolean(formik.touched.prTemplate && formik.errors.prTemplate && !firstEvaTemplate) : null}
                                fullWidth
                                helperText={formik.values.pr ? (formik.touched.prTemplate && formik.errors.prTemplate && !firstEvaTemplate) : null}
                                name="prTemplate"
                                classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                                sx={{ marginBottom: 0, marginTop: '16px', paddingLeft: 0 }}
                                disabled={launchForm}
                            >
                                <MenuItem disabled value=''>
                                    <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.prTemplate')}</Typography>
                                </MenuItem>
                                {
                                    monthly.map(item => {
                                        return (
                                            <MenuItem value={item.serial} key={item.serial}>
                                                {item.code}
                                            </MenuItem>
                                        )
                                    })
                                }
                            </Select>
                            {(formik.touched.prTemplate && formik.errors.prTemplate && !firstEvaTemplate) ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.prTemplate} </FormHelperText>) : <></>}
                        </Box>
                    }
                </Grid>
            </Grid>
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const competencyForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.competency?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.competency?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.competency?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.competency?.nameEn && formik.errors.competency?.nameEn && !firstCompetencyTemplate) || Util.formatData(formik?.values?.competency?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.competency?.nameEn && !firstCompetencyTemplate) && formik.errors.competency?.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "competency.nameEn")}
                        type="text"
                        value={formik.values.competency.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.competency?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.competency?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.competency?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.competency?.nameTh && formik.errors.competency?.nameTh && !firstCompetencyTemplate) || Util.formatData(formik?.values?.competency?.nameTh, "").length > 100}
                        helperText={(formik.touched.competency?.nameTh && !firstCompetencyTemplate) && formik.errors.competency?.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "competency.nameTh")}
                        type="text"
                        value={formik.values.competency.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "competency.descriptionEn")}
                        type="text"
                        value={formik.values.competency.descriptionEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "competency.descriptionTh")}
                        type="text"
                        value={formik.values.competency.descriptionTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            {showGoalTable(formik.errors.competency?.competencyType, formik.touched.competency.competencyType, formik.values.competency.competencyType, 'competency.competencyType', 'competency', formik.values.competency, firstCompetencyTemplate)}
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const competencyProbationForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.competency?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.competency?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.competency?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.competency?.nameEn && formik.errors.probation?.competency?.nameEn && !firstProbationCompetencyTemplate) || Util.formatData(formik?.values?.probation?.competency?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.probation?.competency?.nameEn && !firstProbationCompetencyTemplate) && formik.errors.probation?.competency?.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.competency.nameEn")}
                        type="text"
                        value={formik.values.probation.competency.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.competency?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.competency?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.competency?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.competency?.nameTh && formik.errors.probation?.competency?.nameTh && !firstProbationCompetencyTemplate) || Util.formatData(formik?.values?.probation?.competency?.nameTh, "").length > 100}
                        helperText={(formik.touched.probation?.competency?.nameTh && !firstProbationCompetencyTemplate) && formik.errors.probation?.competency?.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.competency.nameTh")}
                        type="text"
                        value={formik.values.probation.competency.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionEn"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.competency.descriptionEn")}
                        type="text"
                        value={formik.values.probation.competency.descriptionEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                    <TextField
                        fullWidth
                        margin="normal"
                        name="descriptionTh"
                        disabled={serial !== undefined ? true : false}
                        onBlur={formik.handleBlur}
                        onChange={e => formikChange(e, "probation.competency.descriptionTh")}
                        type="text"
                        value={formik.values.probation.competency.descriptionTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            {(formik.values.probation?.competency && formik.values.probation?.competency?.competencyType?.length > 0) &&
                showGoalTable(formik.errors.probation?.competency?.competencyType, formik.touched.probation?.competency?.competencyType, formik.values.probation?.competency?.competencyType, 'probation.competency.competencyType', 'probation.competency', formik.values.probation.competency, firstProbationCompetencyTemplate)
            }
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const goalForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.goal?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.goal?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.goal?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.goal?.nameEn && formik.errors.goal?.nameEn && !firstGoalTemplate) || Util.formatData(formik?.values?.goal?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.goal?.nameEn && !firstGoalTemplate) && formik.errors.goal?.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onChange={e => formikChange(e, "goal.nameEn")}
                        type="text"
                        value={formik.values.goal.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.goal?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.goal?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.goal?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.goal?.nameTh && formik.errors.goal?.nameTh && !firstGoalTemplate) || Util.formatData(formik?.values?.goal?.nameTh, "").length > 100}
                        helperText={(formik.touched.goal?.nameTh && !firstGoalTemplate) && formik.errors.goal?.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onChange={e => formikChange(e, "goal.nameTh")}
                        type="text"
                        value={formik.values.goal.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            {formik.values.goal.descriptionEn
                ?
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionEn"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "goal.descriptionEn")}
                            type="text"
                            value={formik.values.goal.descriptionEn}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
                :
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionEn"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "goal.descriptionEn")}
                            type="text"
                            value={""}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
            }
            {formik.values.goal.descriptionTh
                ?
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionTh"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "goal.descriptionTh")}
                            type="text"
                            value={formik.values.goal.descriptionTh}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
                :
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionTh"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "goal.descriptionTh")}
                            type="text"
                            value={""}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
            }

            <Grid container lg={6} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.workflow')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.goal.workflow}
                        onChange={e => formikChange(e, "goal.workflow")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.workflow')}
                        error={Boolean(formik.touched.goal?.workflow && formik.errors.goal?.workflow && !firstGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.goal?.workflow && formik.errors.goal?.workflow && !firstGoalTemplate}
                        name="workflow"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.workflow')}</Typography>
                        </MenuItem>
                        {
                            goalWorkflowList?.length > 0 ?
                                goalWorkflowList.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.description}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.goal?.workflow && formik.errors.goal?.workflow && !firstGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.goal.workflow} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {formik.values.goal?.workflow &&
                showWorkflowTable(formik.values.goal, formik.errors.goal, formik.touched.goal, 'goal.', false, false, false, false, firstGoalTemplate, false)
            }
            {showGoalTable(formik.errors.goal?.goalCategory, formik.touched.goal?.goalCategory, formik.values.goal?.goalCategory, 'goal.goalCategory', 'goal', formik.values.goal, firstGoalTemplate)}
            {(formik.values?.goal?.type).length > 0 &&
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.permissionGoal')}</Typography>
                        {formik.values?.goal?.type?.map((data, idx) => {
                            return <Grid container direction="row">
                                <Grid item>
                                    <Checkbox
                                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.checkBoxStyle }}
                                        value={data.is_default || false}
                                        checked={data.is_default || false}
                                        disabled={launchForm}
                                        onChange={e => formikChangeCheckbox(e, `goal.type[${idx}].is_default`)} />
                                </Grid>
                                <Grid item sx={{ alignSelf: 'center' }}>
                                    <Typography classes={{ root: classes.checkboxLabel }}>{data.name}</Typography>
                                </Grid>
                            </Grid>
                        })}
                    </Grid>
                </Grid>
            }


            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'} >
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.label.editGoal')}</Typography>
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox
                                classes={{ root: classes.checkBoxStyle }}
                                value={formik.values.allow_evaluator_edit_goal}
                                checked={formik.values.allow_evaluator_edit_goal}
                                onChange={e => formikChangeCheckbox(e, 'allow_evaluator_edit_goal')} />
                        </Grid>
                        <Grid item sx={{ alignSelf: 'center' }}>
                            <Typography classes={{ root: classes.checkboxLabel }}>{t('admin.inputForm.allowEvaluatorEditGoal')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>

            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.goalGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.goal.goalGroup}
                        onChange={e => formikChange(e, "goal.goalGroup")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.goalGroup')}
                        error={Boolean(formik.touched.goal?.goalGroup && formik.errors.goal?.goalGroup && !firstGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.goal?.goalGroup && formik.errors.goal?.goalGroup && !firstGoalTemplate}
                        name="goalGroup"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.goalGroup')}</Typography>
                        </MenuItem>
                        {
                            goalProgress?.length > 0 ?
                                goalProgress.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFound')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.goal?.goalGroup && formik.errors.goal?.goalGroup && !firstGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.goal?.goalGroup} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {formik.values.goal.goalGroup &&
                showDisplayGoalTable(formik.values.goal.goalProgress)
            }
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.goalLibrary')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.goal.goalLibrary}
                        onChange={e => formikChange(e, "goal.goalLibrary")}
                        defaultValue=""
                        displayEmpty
                        error={formik.values.goal?.goalLibrary ? Boolean(formik.touched.goal?.goalLibrary && formik.errors.goal?.goalLibrary && !firstGoalTemplate) : null}
                        fullWidth
                        helperText={formik.values.goal?.goalLibrary ? formik.touched.goal?.goalLibrary && formik.errors.goal?.goalLibrary && !firstGoalTemplate : null}
                        name="goalLibrary"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        disabled={launchForm}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                    >
                        {
                            goalLibrary?.length > 0 ?
                                goalLibrary.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name} {item.is_default ? ' (Default)' : null}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.goal?.goalLibrary && formik.errors.goal?.goalLibrary ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.goal?.goalLibrary} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {/* <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox 
                              classes={{root: classes.checkBoxStyle}}
                              value={formik.values.goal.scaleMapping}
                              checked={formik.values.goal.scaleMapping}
                              onChange={e => formikChangeCheckbox(e, 'goal.scaleMapping')} />
                        </Grid>
                        <Grid item sx={{alignSelf: 'center'}}>
                            <Typography classes={{root: classes.checkboxLabel}}>{t('admin.inputForm.scaleMapping')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> */}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.ratingScale')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.goal.ratingScale}
                        onChange={e => formikChange(e, "goal.ratingScale")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.ratingScale')}
                        error={Boolean(formik.touched.goal?.ratingScale && formik.errors.goal?.ratingScale && !firstGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.goal?.ratingScale && formik.errors.goal?.ratingScale && !firstGoalTemplate}
                        name="ratingScale"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        disabled={launchForm}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.ratingScale')}</Typography>
                        </MenuItem>
                        {
                            ratingScale?.length > 0 ?
                                ratingScale.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.goal?.ratingScale && formik.errors.goal?.ratingScale && !firstGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.goal?.ratingScale} </FormHelperText>) : <></>}
                </Grid>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.expectRating')}</Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.goal.expectRating}
                        onChange={e => formikChange(e, "goal.expectRating")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.expectRating')}
                        fullWidth
                        name="expectRating"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        disabled={launchForm}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                    >
                        <MenuItem value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.expectRating')}</Typography>
                        </MenuItem>
                        {
                            expectRating?.length > 0 ?
                                expectRating.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.value}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                </Grid>
            </Grid>
            {(formik.values.goal.ratingScale) &&
                showRatingScale(formik.errors.goal?.ratingScaleList, formik.touched.goal?.ratingScaleList, formik.values.goal?.ratingScaleList, 'goal.ratingScaleList')
            }
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const goalProbationForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 30px 0px" }} />
                </Grid>
            </Grid>
            {codeAndCycleForm()}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameEn')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.goal?.nameEn, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.goal?.nameEn, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.goal?.nameEn, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.goal?.nameEn && formik.errors.probation?.goal?.nameEn && !firstProbationGoalTemplate) || Util.formatData(formik?.values?.probation?.goal?.nameEn, "").length > 100}
                        fullWidth
                        helperText={(formik.touched.probation?.goal?.nameEn && !firstProbationGoalTemplate) && formik.errors.probation?.goal?.nameEn}
                        margin="normal"
                        name="nameEn"
                        disabled={serial !== undefined ? true : false}
                        onChange={e => formikChange(e, "probation.goal.nameEn")}
                        type="text"
                        value={formik.values.probation.goal.nameEn}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameEn')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.nameTh')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                        <Typography fontSize="14px" fontWeight="400" color={Util.formatData(formik?.values?.probation?.goal?.nameTh, "").length === 0 ? "#D8D8D8" : Util.formatData(formik?.values?.probation?.goal?.nameTh, "").length <= 100 ? "#5DA196" : "#CC6058"}>{Util.formatData(formik?.values?.probation?.goal?.nameTh, "").length}/100</Typography>
                    </Box>
                    <TextField
                        error={Boolean(formik.touched.probation?.goal?.nameTh && formik.errors.probation?.goal?.nameTh && !firstProbationGoalTemplate) || Util.formatData(formik?.values?.probation?.goal?.nameTh, "").length > 100}
                        helperText={(formik.touched.probation?.goal?.nameTh && !firstProbationGoalTemplate) && formik.errors.probation?.goal?.nameTh}
                        fullWidth
                        margin="normal"
                        name="nameTh"
                        disabled={serial !== undefined ? true : false}
                        onChange={e => formikChange(e, "probation.goal.nameTh")}
                        type="text"
                        value={formik.values.probation.goal.nameTh}
                        variant="outlined"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        placeholder={t('admin.inputForm.placeholder.nameTh')}
                        classes={{ root: classes.input }}
                    />
                </Grid>
            </Grid>
            {formik.values.probation.goal.descriptionEn
                ?
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionEn"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "probation.goal.descriptionEn")}
                            type="text"
                            value={formik.values.probation.goal.descriptionEn}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
                :
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionEn')} </Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionEn"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "probation.goal.descriptionEn")}
                            type="text"
                            value={""}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionEn')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
            }
            {formik.values.probation.goal.descriptionTh
                ?
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionTh"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "probation.goal.descriptionTh")}
                            type="text"
                            value={formik.values.probation.goal.descriptionTh}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
                :
                <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                    <Grid item lg md xs={12} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.instructionTh')}</Typography>
                        <TextField
                            fullWidth
                            margin="normal"
                            name="descriptionTh"
                            disabled={serial !== undefined ? true : false}
                            onBlur={formik.handleBlur}
                            onChange={e => formikChange(e, "probation.goal.descriptionTh")}
                            type="text"
                            value={""}
                            variant="outlined"
                            InputLabelProps={{
                                shrink: true,
                            }}
                            placeholder={t('admin.inputForm.placeholder.descriptionTh')}
                            classes={{ root: classes.input }}
                        />
                    </Grid>
                </Grid>
            }

            <Grid container lg={12} md={6} xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.workflow')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.goal.workflow}
                        onChange={e => formikChange(e, "probation.goal.workflow")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.workflow')}
                        error={Boolean(formik.touched.probation?.goal?.workflow && formik.errors.probation?.goal?.workflow && !firstProbationGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.goal?.workflow && formik.errors.probation?.goal?.workflow && !firstProbationGoalTemplate}
                        name="workflow"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.workflow')}</Typography>
                        </MenuItem>
                        {
                            goalWorkflowList?.length > 0 ?
                                goalWorkflowList.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.description}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.goal?.workflow && formik.errors.probation?.goal?.workflow && !firstProbationGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.goal?.workflow} </FormHelperText>) : <></>}
                </Grid>
                {/* <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.endDate')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Grid container direction="row">
                        <Grid item lg={1} md={1} xs={1}>
                            <TextField
                                fullWidth
                                margin="normal"
                                name="endDate"
                                disabled={serial !== undefined ? true : false}
                                onBlur={formik.handleBlur}
                                onChange={e => formikChange(e, "probation.goal.endDate")}
                                type="text"
                                value={formik.values.probation.goal.endDate}
                                variant="outlined"
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                placeholder={'0'}
                                classes={{ root: classes.input }}
                            />
                        </Grid>
                        <Grid item lg={5} md={5} xs={5}>
                            <Typography sx={{marginTop: '35px', marginLeft: '15px'}} classes={{ root: classes.checkboxLabel }}>{'Days from Employee Start Date'}</Typography>
                        </Grid>
                    </Grid>
                </Grid> */}
            </Grid>
            {formik.values.probation?.goal?.workflow &&
                showWorkflowTable(formik.values.probation.goal, formik.errors.probation?.goal, formik.touched.probation?.goal, 'probation.goal.', false, false, false, false, firstProbationGoalTemplate, true)
            }
            {showGoalTable(formik.errors.probation?.goal?.goalCategory, formik.touched.probation?.goal?.goalCategory, formik.values.probation?.goal?.goalCategory, 'probation.goal.goalCategory', 'probation.goal', formik.values.probation.goal, firstProbationGoalTemplate)}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.goalGroup')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.goal.goalGroup}
                        onChange={e => formikChange(e, "probation.goal.goalGroup")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.goalGroup')}
                        error={Boolean(formik.touched.probation?.goal?.goalGroup && formik.errors.probation?.goal?.goalGroup && !firstProbationGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.goal?.goalGroup && formik.errors.probation?.goal?.goalGroup && !firstProbationGoalTemplate}
                        name="goalGroup"
                        classes={{ root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        diabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.goalGroup')}</Typography>
                        </MenuItem>
                        {
                            goalProgress?.length > 0 ?
                                goalProgress.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFound')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.goal?.goalGroup && formik.errors.probation?.goal?.goalGroup && !firstProbationGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.goal?.goalGroup} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {formik.values.probation.goal.goalGroup &&
                showDisplayGoalTable(formik.values.probation.goal.goalProgress)
            }
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.goalLibrary')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.goal.goalLibrary}
                        onChange={e => formikChange(e, "probation.goal.goalLibrary")}
                        defaultValue=""
                        displayEmpty
                        error={formik.values.probation?.goal?.goalLibrary ? Boolean(formik.touched.probation?.goal?.goalLibrary && formik.errors.probation?.goal?.goalLibrary && !firstProbationGoalTemplate) : null}
                        fullWidth
                        helperText={formik.values.probation?.goal?.goalLibrary ? formik.touched.probation?.goal?.goalLibrary && formik.errors.probation?.goal?.goalLibrary && !firstProbationGoalTemplate : null}
                        name="goalLibrary"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        {
                            goalLibrary?.length > 0 ?
                                goalLibrary.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name} {item.is_default ? ' (Default)' : null}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.goal?.goalLibrary && formik.errors.probation?.goal?.goalLibrary ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.goal?.goalLibrary} </FormHelperText>) : <></>}
                </Grid>
            </Grid>
            {/* <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Grid container direction="row">
                        <Grid item>
                            <Checkbox 
                              classes={{root: classes.checkBoxStyle}}
                              value={formik.values.goal.scaleMapping}
                              checked={formik.values.goal.scaleMapping}
                              onChange={e => formikChangeCheckbox(e, 'goal.scaleMapping')} />
                        </Grid>
                        <Grid item sx={{alignSelf: 'center'}}>
                            <Typography classes={{root: classes.checkboxLabel}}>{t('admin.inputForm.scaleMapping')}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid> */}
            <Grid container lg md xs={12} display="inline-flex" spacing={4} mt={'25px'}>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.ratingScale')} <Box fontStyle="italic" sx={{ fontWeight: 200, marginLeft: "5px", color: "#CC6058 " }}> *</Box></Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.goal.ratingScale}
                        onChange={e => formikChange(e, "probation.goal.ratingScale")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.ratingScale')}
                        error={Boolean(formik.touched.probation?.goal?.ratingScale && formik.errors.probation?.goal?.ratingScale && !firstProbationGoalTemplate)}
                        fullWidth
                        helperText={formik.touched.probation?.goal?.ratingScale && formik.errors.probation?.goal?.ratingScale && !firstProbationGoalTemplate}
                        name="ratingScale"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem disabled value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.ratingScale')}</Typography>
                        </MenuItem>
                        {
                            ratingScale?.length > 0 ?
                                ratingScale.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.name}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                    {formik.touched.probation?.goal?.ratingScale && formik.errors.probation?.goal?.ratingScale && !firstProbationGoalTemplate ? (<FormHelperText error sx={{ marginTop: "4px", marginRight: "14px", marginBottom: 0, marginLeft: "14px" }}>{formik.errors.probation?.goal?.ratingScale} </FormHelperText>) : <></>}
                </Grid>
                <Grid item lg={6} md={6} xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                    <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.expectRating')}</Typography>
                    <Select
                        id="workload-select"
                        inputlabelprops={{ shrink: false }}
                        variant="outlined"
                        size="small"
                        value={formik.values.probation.goal.expectRating}
                        onChange={e => formikChange(e, "probation.goal.expectRating")}
                        defaultValue=""
                        displayEmpty
                        placeholder={t('admin.inputForm.placeholder.expectRating')}
                        fullWidth
                        name="expectRating"
                        classes={launchForm ? { root: classes.selectDisabled } : { root: classes.input }}
                        sx={{ marginBottom: 0, marginTop: '16px' }}
                        disabled={launchForm}
                    >
                        <MenuItem value="">
                            <Typography variant="sub_label" style={{ fontWeight: "300", color: "#AAAAAA" }}>{t('admin.inputForm.placeholder.expectRating')}</Typography>
                        </MenuItem>
                        {
                            expectRating?.length > 0 ?
                                expectRating.map(item => {
                                    return (
                                        <MenuItem value={item.serial} key={item.serial}>
                                            {item.value}
                                        </MenuItem>
                                    )
                                })

                                : <MenuItem value="">
                                    ---{t('label.notFund')}---
                                </MenuItem>
                        }
                    </Select>
                </Grid>
            </Grid>
            {(formik.values.probation.goal.ratingScale) &&
                showRatingScale(formik.errors.probation?.goal?.ratingScaleList, formik.touched.probation?.goal?.ratingScaleList, formik.values.probation?.goal?.ratingScaleList, 'probation.goal.ratingScaleList')
            }
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        {activeStep !== steps.length - 1
                            &&
                            <Button onClick={handleSubmit} color="primary" variant="contained" fullWidth>
                                {activeStep !== steps.length - 1 ? t(`label.next`) : t(`label.create`)}
                            </Button>
                        }
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const summaryForm = () => {
        return <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "20px 0px 25px 30px" }} classes={{ root: classes.error }}>
            <Grid container lg md xs={12} direction="column">
                <Grid item lg md xs={12}>
                    <Typography classes={{ root: classes.titleName }}>
                        {steps[activeStep]}
                    </Typography>
                </Grid>
                <Grid item lg md xs={12}>
                    <Divider sx={{ margin: "15px 31px 0px 0px" }} />
                </Grid>
            </Grid>

            {isProbation ?
                showSummary(formik.values.probation.summary)
                :
                showSummary(formik.values.summary)
            }
            <Grid container mt={3} mb={3} pr={4} >
                <Grid item xs display="flex" flexDirection="row-reverse">
                    <Box sx={{ width: "100px" }}>
                        <Button onClick={createJourney} color="primary" variant="contained" fullWidth>
                            {activeStep !== steps.length - 1 ? t(`label.next`) : type === 'edit' ? t('label.save') : t(`label.create`)}
                        </Button>
                    </Box>
                    <Box mr={"30px"} sx={{ width: "100px" }}>
                        {activeStep === 0
                            ?
                            <Button color="black" variant="outlined" fullWidth onClick={handleCancel}>
                                {t('label.cancel')}
                            </Button>
                            :
                            <Button color="black" variant="outlined" fullWidth onClick={handleBack}>
                                {t('label.back')}
                            </Button>
                        }
                    </Box>
                </Grid>
            </Grid>
        </Paper>
    }

    const codeAndCycleForm = () => {
        return <Grid container lg md xs={12} display="inline-flex" spacing={4}>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important", ".MuiInputBase-input": { "background-color": serial !== undefined ? "#FAFAFA" : "", "-webkit-text-fill-color": serial !== undefined ? "#000 !important" : "" }, "fieldset": { "border-color": serial !== undefined ? "#FFFFFF !important" : "" } }}>
                <Grid container lg md xs={12}>
                    <Grid item lg={2} md={2} xs={2}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.code')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography classes={{ root: classes.textShow }} lineHeight="24px" display="flex">{formik.values.code}</Typography>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item lg md xs={6} sx={{ paddingTop: "0 !important" }}>
                <Grid container lg md xs={12}>
                    <Grid item lg={2} md={2} xs={2}>
                        <Typography classes={{ root: classes.requiredTitle }} lineHeight="24px" display="flex">{t('admin.inputForm.cycle')}</Typography>
                    </Grid>
                    <Grid item>
                        <Typography classes={{ root: classes.textShow }} lineHeight="24px" display="flex">{cycleList.filter((v) => v.serial === formik.values.cycle).length > 0 ? cycleList.filter((v) => v.serial === formik.values.cycle)[0].name : ''}</Typography>
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    }

    let changeStepTo1 = () => {
        setActiveStep(0)
        setShow360(false)
    }
    return (
        <>
            <Box id="back-to-top-anchor"> </Box>
            <Helmet>
                <title>HOME | PMS </title>
            </Helmet>
            <Box
                sx={{
                    backgroundColor: 'background.default',
                    minHeight: '100%',
                    py: 3
                }}
            >
                <Container maxWidth="xl">
                    <Grid container pt={2} pb={2}>
                        <Typography fontSize={16} lineHeight={1} color="#68717A">
                            <span style={styles.link} onClick={() => clickLink('/admin/evaluation-journey')}>
                                {t('admin.label.evaluationJourney')}
                            </span> /&nbsp;
                            <span style={styles.end} >
                                {type === 'edit' ? t('admin.label.evaluationJourneyEdit') : type === 'duplicate' ? t('admin.label.evaluationJourneyDuplicate') : t('admin.label.evaluationJourneyCreate')}
                            </span>
                        </Typography>
                    </Grid>
                    <Grid container spacing={2}>
                        <Grid item xs={12} >
                            <Typography variant="h1" fontSize={36} lineHeight="53.82px" fontWeight="500" color="#404349">
                                {type === 'edit' ? t('admin.label.evaluationJourneyEdit') : type === 'duplicate' ? t('admin.label.evaluationJourneyDuplicate') : t('admin.label.evaluationJourneyCreate')}
                            </Typography>
                        </Grid>
                        {cycleType === "360" && show360 === true && codeExist !== true ? <EvaluationJourney360 oldData={oldData} cycleID={state?.cycleID} options={options} changeStepTo1={changeStepTo1} competencyType={competencyType} customFormList={customFormList} evaluationComponent={evaluationComponent} code={formik.values.code} workflowList={workflowList} cycle={formik.values.cycle} cycleList={cycleList} serial={state?.serial} type={type} show360={show360} cycleType={cycleType}></EvaluationJourney360> :
                            <Grid direction="column" sx={{}}
                                container item
                                justifyContent="center"
                                alignItems="center">

                                <Grid container sx={{ marginBottom: '30px' }}>
                                    <Paper elevation={6} sx={{ 'border-radius': '20px', width: '100%', padding: "30px 260px 29px 255px" }} classes={{ root: classes.error }}>
                                        <Stepper activeStep={activeStep} className={classes.root} alternativeLabel>
                                            {steps.map((label) => (
                                                <Step
                                                    key={label}
                                                >
                                                    <StepLabel>{label}</StepLabel>
                                                </Step>
                                            ))}
                                        </Stepper>
                                    </Paper>
                                </Grid>

                                <Grid container item>
                                    {getStepContent(activeStep)}
                                </Grid>
                            </Grid>
                        }
                    </Grid>
                    <SimpleDialog
                        open={isSuccessAddDialogOpen}
                        doDirect={() => handleDirect()}
                        setValue={openSuccessAddDialog}
                        text={t(`admin.label.evaluationCreatedSuccessfully`)}
                        page={true}
                    />
                    <MessageDialog
                        open={openFailedMessageDialog}
                        setValue={handleCloseFailedMessageDialog}
                        type="fail"
                        title={t(`dialog.label.fail`)}
                        text={t(`admin.label.evaluationCreatedFail`)}
                    />
                    <ConfirmDialog open={discardDialog} warning={true} doConfirm={() => handleDiscardChangeConfirm()} setValue={() => handleDiscardDialog(false)} title={t('label.confirmationOfDiscard')} text={t('label.youSureDiscardChange')} />
                    <SimpleDialog page={true} open={isSuccessOpen} setValue={openSuccessOpen} doDirect={() => handleSuccess()} title={t('mygoal.popup.success')} text={type === 'edit' || type === 'duplicate' ? t('admin.popup.evaluationJourneySave') : t('admin.popup.evaluationJourneyCreate')} />
                </Container>
            </Box>
        </>
    )
};
export default EvaluationJourneyCreate;
